/**
 * GENERATED FILE — German gender and plural lexicon. DO NOT EDIT BY HAND.
 *
 * Emitted by data-pipeline/run-nouns.ts from the Wiktionary (wiktextract)
 * dump at kaikki.org. Data licence: CC BY-SA — see LICENSE-DATA.md.
 *
 * Only entries the rules get wrong are stored: gender where the ending
 * heuristic misleads (6181 of 51085 nouns), and plurals the
 * rules do not produce (4417 of 48110 attested).
 *
 * Compounds are not stored: they are resolved from their final element,
 * which is why a lexicon of 6181 entries covers 51085 nouns —
 * and every compound built on one of those heads, listed or not.
 */
import type { GrammaticalGender } from "../core/features.js";

const GENDER_DATA = `*rschl*ch|n
10-eck|n
11-eck|n
12-eck|n
13-eck|n
14-eck|n
15-eck|n
16-eck|n
17-eck|n
18-eck|n
19-eck|n
20-eck|n
21-eck|n
22-eck|n
24-eck|n
27-eck|n
28-eck|n
3-eck|n
30-eck|n
31-eck|n
32-eck|n
34-eck|n
36-eck|n
4-eck|n
40-eck|n
48-eck|n
5-eck|n
50-eck|n
51-eck|n
6-eck|n
60-eck|n
7-eck|n
70-eck|n
8-eck|n
80-eck|n
9-eck|n
a|n
ä|n
a-dur|n
a-moll|n
a-schwa|n
aa|n
aak|n
aalauge|m
aalleiter|f
aalschwanz|m
aam|f
aas|n
aaß|n
aba|f
abart|f
abaton|n
abbaggern|n
abbild|n
abbruchfirma|f
abbruchhaus|n
abc|n
abdach|n
abdrucken|n
abece|n
abenomics|f
abenteuer|n
aber|n
abfahrt|f
abfertigungsgebäude|n
abfuhr|f
abgas|n
abgeordnetenhaus|n
abh|f
abh.|f
abhärten|n
abhäuten|n
abi|n
abitur|n
abklingen|n
abknöpfen|n
abkommen|n
abluft|f
abmelken|n
abnibbeln|n
abo|n
aborigine|m
abrücken|n
abschnittsende|n
abschrift|f
abschwung|m
abseits|n
abseitstor|n
absicht|f
absinthöl|n
absolutbetrag|n
abteiltür|f
abwahl|f
abwasser|n
abwehr|f
abzapfen|n
accessoire|n
acetal|n
acetat|n
achsel|f
acht|f
achteck|n
achterl|n
achtunddreißig|f
achtundvierzig|f
achtundzwanzig|f
achtzig|f
achtzigeck|n
actinoid|n
acyloin|n
adabei|m
adamin|n
additiv|n
addukt|n
ade|n
adeliepinguin|m
adenin|n
adenom|n
ader|f
adieu|n
adjektiv|n
adjunkt|n
adkopula|f
adobe|m
ads|n
adstrat|n
adstringens|n
adventkranz|m
adventskranz|m
adventskuchen|m
adverb|n
aegyptier|m
aera|f
aerobic|n
aerobier|m
aerogel|n
aerosol|n
afa|f
affenarschloch|n
äffin|f
affix|n
affixoid|n
aftershave|n
agenda|f
agens|n
agglo|f
aggregat|n
agio|n
agioteur|m
agora|f
ahnin|f
aids|n
ais|n
akh|n
akkordeon|n
akkreditiv|n
akronym|n
akrostichon|n
akteur|m
aktienanteil|m
aktionsart|f
aktiv|n
akupunkteur|m
akw|n
alabandin|m
alanin|n
albedo|f
albumin|n
ale|n
alexin|n
alfabet|n
alfalfa|f
algebra|f
alibi|n
alija|f
alinea|n
aliya|f
alkali|n
alkalilauge|f
alkaloid|n
alkan|n
alken|n
alkin|n
alkoholat|n
alkoholsteuer|f
alkyl|n
allegretto|n
allel|n
allergen|n
allerheiligen|n
allerlei|n
allophon|n
allotria|n
alm|f
almandin|m
almosen|n
alpacca|n
alpaka|n
alpenglühen|n
alpental|n
alpha|n
alphabet|n
alster|n
alter|n
altimeter|n
altreich|n
aluminat|n
am|n
amalgam|n
amaryllis|f
amateur|m
ambra|f
ambrosia|f
ametrin|m
amid|n
amin|n
ammer|f
ammoniakat|n
ammoniumion|n
ampel|f
ampel-aus|n
ampere|n
amphetamin|n
amsel|f
amt|n
amtstitel|m
amulett|n
amygdala|f
amylen|n
anakonda|f
analogon|n
analoguhr|f
ananas|f
ananaskuchen|m
anapher|f
anbot|n
anchovis|f
andenken|n
androgen|n
andrücken|n
anfahrt|f
anfreunden|n
anfurt|f
angebot|n
angel|f
angesicht|n
angina|f
angiotensin|n
angst|f
ångström|n
anhängsel|n
anhydrid|n
anima|f
animateur|m
anime|m
anion|n
anis|m
anisette|m
aniskuchen|m
ankleber|m
anklingen|n
ankunft|f
anleihenanteil|m
anliegen|n
anrecht|n
anrücken|n
anschlusstor|n
anschlußtor|n
anschmeissen|n
anschmeißen|n
anschovis|f
anschrift|f
ansicht|f
ansinnen|n
anspannen|n
anstalt|f
anteil|m
antheil|m
anthocyan|n
antidot|n
antigen|n
antik-uhr|f
antikoagulans|n
antimonerz|n
antimonglanz|m
antimonid|n
antioxidans|n
antiquariat|n
antiquark|n
antitranspirant|n
antlitz|n
antonym|n
antreten|n
antriebsrad|n
antwort|f
anwerfen|n
anwesen|n
anzettel|m
ao|f
aorta|f
apache|m
apastron|n
apfelkorn|m
apfelkuchen|m
apfelpfannkuchen|m
apfelweinkuchen|m
aphel|n
apokryph|n
apostel|m
apostelkuchen|m
apostrophieren|n
app|f
appelkorn|m
appendix|f
applaudeur|m
applet|n
aprikosenkuchen|m
april|m
aprilscherz|m
aquamarin|m
aquarell|n
äquatorialgürtel|m
äquivalent|n
ar*****ch|n
ar***l*ch|n
ära|f
ärar|n
arbeit|f
arbeitsamt|n
arbeitseinsatzingenieur|m
arbeitserlaubnis|f
arch.|n
archiv|n
areal|n
arena|f
arfvedsonit|f
arginin|n
argwöhnen|n
ariseur|m
arista|f
armbanduhr|f
armenhaus|n
arnika|f
arpeggio|n
arrangeur|m
arsan|n
arschin|m
arschloch|n
arsenal|n
arsenat|n
arsenid|n
arsenit|n
arsenkupfer|n
arsenobetain|n
arsenocholin|n
arsenopyrit|n
arsin|n
arsoran|n
arsphenamin|n
art|f
artefakt|n
artenreichtum|m
artepithet|n
artikelende|n
artikulationsart|f
arylamin|n
ärztinn|f
arztkittel|m
arzttermin|m
as|n
as-dur|n
asana|f
aschenkuchen|m
aschkuchen|m
asp|f
aspartam|n
aspartat|n
aspie|m
aspirata|f
asr|f
ass|n
assel|f
aster|f
astloch|n
asyl|n
asyndeton|n
at|n
atelier|n
atemgas|n
atherom|n
atoll|n
atom|n
atomprozent|n
atomuhr|f
atrazin|n
atriumhaus|n
attentat|n
attest|n
attika|f
attribut|n
au|f
au-pair|n
audimax|n
audio|n
audiobook|n
audiothek|f
aufeinanderprallen|n
aufenthaltserlaubnis|f
aufenthaltstitel|m
aufhocker|n
aufkleber|m
aufkommen|n
aufläger|n
aufruhr|m
aufrücken|n
aufschnittmesser|n
aufschrei|m
aufschwung|m
aufsetzen|n
aufwand|m
aug|n
auge|n
augenlid|n
augenmerk|n
augmentativ|n
auktionshaus|n
aula|f
aura|f
aurora|f
aus|n
ausapern|n
ausfuhr|f
ausfuhrzettel|m
ausgangstür|f
auskunft|f
ausmaß|n
auspfeifen|n
ausr.|n
ausreiseerlaubnis|f
ausrücken|n
ausschließen|n
außenohr|n
aussortieren|n
ausspannen|n
aussterben|n
aussteuer|f
ausstiegstür|f
auster|f
austernmesser|n
auswendiglernen|n
auto|n
autodafé|n
autodrom|n
autohaus|n
automatenrestaurant|n
automatikgetriebe|n
automatikuhr|f
autosemantikon|n
autotür|f
auxiliar|n
ave|n
ave-maria|n
aviso|n
avocado|f
axiom|n
axon|n
axt|f
ayahuasca|n
azetat|n
azid|n
azimut|n
b|n
b-dur|n
baba|f
babuschka|f
baby|n
babyöl|n
bacchanal|n
bachen|m
back|f
backend|n
backenknochen|m
backhaus|n
backronym|n
bad|n
badehaus|n
badelatschen|m
bademantel|m
badesee|m
badhaus|n
badi|f
bafög|n
baguette|n
bahn|f
bahnhofsuhr|f
bahuvrihi|n
bai|f
bain-marie|n
baiserkuchen|m
bajonett|n
bakkalaurea|f
bakkalaureat|n
bakkie|m
baklava|n
bakschisch|n
bakterizid|n
balalaika|f
baldachin|m
balkontür|f
ballast|m
bällebad|n
ballerina|f
ballett|n
balley|f
balz|f
bamia|f
banalitaet|f
bananenkuchen|m
band|n
banjo|n
bank|f
bankerl|n
bankett|n
bankhaus|n
banner|n
bar|f
barbier|m
barbiturat|n
bärendreck|m
barett|n
bärin|f
bark|f
barockstil|m
barrel|n
barterl|n
bärwurz|m
baryon|n
baryton|n
baschlik|m
basecap|n
bashing|n
basilika|f
bassbox|f
bassin|n
bataillon|n
bauart|f
bauchtanz|m
bauchweh|n
bauernhaus|n
bauingenieur|m
baum-art|f
baumart|f
baumhaus|n
baumkuchen|m
baumnuß|f
baumwollkuchen|m
baumwollmantel|m
baumwollmischgewebe|n
baumwollsaatkuchen|m
baumwollsamenkuchen|m
baustil|m
bazooka|f
be|n
beatbox|f
beatnik|m
beau|m
bébé|n
beben|n
becken|n
becquerel|n
bedacht|m
bedenken|n
bedürfniss|n
beefsteak|m
beer|f
beet|n
befr.|n
befugnis|f
begehren|n
beige|n
bein|n
beinhaus|n
beisl|n
beissreflex|m
beißreflex|m
beitel|m
beiz|f
bekandtnuß|n
belchen|m
beluga|f
benjamin|m
benthos|n
benz|m
benzin|n
benzinuhr|f
benzo|n
benzol|n
berdysch|f
bergahorn|m
bergtal|n
beryllat|n
berylliumerz|n
bes|n
besiedeln|n
besorgnis|f
bestandteil|m
bestandtheil|m
bestattungsart|f
besteck|n
beta|n
betain|n
betel|m
beteuern|n
betracht|m
betrübnis|f
bett|n
bette|n
betthupferl|n
beugel|n
beuschel|n
beutegut|n
beutel|m
bewandtnis|f
bewerbungsfrist|f
beyl|n
beyn|n
beytel|m
beziehungstat|f
bezirksamt|n
bib|f
bibel|f
biberschwanz|m
bibliothek|f
bicarbonat|n
bidet|n
bienenhaus|n
bienenwachs|n
bier|n
bierfaß|n
bierhaus|n
biest|n
biet|n
bieten|n
bild|n
bildbestandteil|m
billard|n
billet|n
billetdoux|n
billeteur|m
billett|n
bim|f
bimetall|n
bimmeln|n
bindegewebe|n
binden|n
bingo|n
binkerl|n
binnen-i|n
binokel|n
binom|n
bio|n
biogas|n
biolabor|n
biom|n
bioscop|n
bioskop|n
biotop|n
bip|n
biphenyl|n
bipyridin|n
birkenlaub|n
birnenkuchen|m
birnenmus|n
bis|n
biskottenkuchen|m
biskuitkuchen|m
bismut|n
bistro|n
bit|n
bitch|f
bitcoin|m
bitternis|f
bitumen|n
biwak|n
bka|n
bks|n
blabla|n
blackbox|f
blackjack|n
blag|n
blasensprung|m
blasloch|n
blasslila|n
blatt|n
blattader|f
blatter|f
blätterteigkuchen|m
blattgewebe|n
blattlaus|f
blau|n
blaubeerkuchen|m
blaubeerstreuselkuchen|m
blaufelchen|m
blech|n
blechkuchen|m
blei|n
bleierz|n
blicksilber|n
blik|m
blockhaus|n
bluegrass|n
blumenkohlohr|n
blumenkranz|m
blumenuhr|f
blut|n
blutader|f
blutbad|n
blutkuchen|m
blutrot|n
blutrunst|f
bluttat|f
blütenkuchen|m
boa|f
bockerl|n
bocksbeutel|m
bodega|f
bodenart|f
boeing|f
bogenmaß|n
bohnenkuchen|m
bohrloch|n
bokeh|n
bolde|n
bolschewik|m
bombenmantel|m
bombilla|f
bommel|f
bompel|f
bonanzarad|n
bong|f
bonmot|n
bonschen|m
boofke|m
boomtown|f
boot|n
boran|n
borat|n
bord|n
bordell|n
borid|n
borstenschwanz|m
bosna|f
bosner|f
boson|n
bouclé|n
boudoir|n
bouillon|f
boulevardblatt|m
bouquet|n
bowl|f
box|f
boygroup|f
bö|f
börsenaufschwung|m
börsenmantel|m
böse|n
bps|f
brain|n
brainstorming|n
brandmail|f
brandmal|n
brandmaus|f
brandteigkrapferl|n
bratapfelkuchen|m
bräu|n
brauhaus|n
braun|n
braunerz|n
braunlager|m
brausebad|n
braut|f
bre|m
break|n
brechnuß|f
brei|m
breikuchen|m
bremssattel|m
brennen|n
brett|n
brettsegeln|n
bretzel|f
breve|n
brevier|n
brezel|f
brezen|f
brezn|f
bridge|n
briefkastenfirma|f
bries|n
brikett|n
brillenpinguin|m
britschka|f
brockenhaus|n
brod|n
bromalken|n
bromat|n
bromid|n
bromidion|n
bronchoskop|n
brot|n
brotbeutel|m
brotkuchen|m
brotmesser|n
brownie|m
brötli|n
bruchteil|m
brunft|f
brunftschrei|m
brunst|f
brust|f
brut|f
bruttogehalt|n
btmg|n
btw|f
bu|f
bubenspitzle|n
bubespitzle|n
buch|n
buchecker|f
buchen-art|f
buchenart|f
buchenlaub|n
buchstabe|m
bucht|f
buchtel|f
buchtitel|m
buddel|f
budel|f
budget|n
buffet|n
bukett|n
buklee|n
bulletin|n
bully|n
bundesamt|n
bunkeröl|n
burg|f
burgunderrot|n
burin|f
burka|f
business|n
busserl|n
bussi|n
butan|n
butanol|n
butch|f
buten|n
butterfaß|n
butterkuchen|m
buttermesser|n
butylen|n
bux|f
buzzword|n
bübin|f
büfett|n
bündel|n
bürgeramt|n
bürgerhaus|n
büro|n
bürogebäude|n
bürohaus|n
bürotür|f
büschel|n
bütt|f
büttel|m
bütterken|n
bw|n
byte|n
c-dur|n
cabaret|n
cabrio|n
cache|m
cachet|n
cadaverin|n
cadmiumion|n
cafe|n
café|n
cafeteria|f
caldera|f
calendula|f
camera|f
camion|m
camp|n
canapé|n
cape|n
capybara|n
carben|n
carbid|n
carbonat|n
carbonyl|n
carboxy|n
carotin|n
carotinoid|n
carrot-cake|m
cash|n
cashewnuß|f
casino|n
casting|n
catering|n
causa|f
cd|f
cello|n
celsius|n
cembalo|n
cenotaph|n
center|n
cermet|n
ces|n
chabo|n
chakra|n
chalkogen|n
chalkogenid|n
chalkosin|m
chamäleon|n
champion|m
chanat|n
chanson|n
chanukkia|f
chaos|n
chapeau|m
charmeur|m
charta|f
chassis|n
chauffeur|m
chay|f
chaya|f
checkbox|f
chefredakteur|m
chelat|n
cheminée|n
chemo|f
chemokin|n
chemotaxis|f
chemtrail|m
cherimoya|f
chi|n
chiaroscuro|n
chick|n
chicken|n
chicken-nugget|n
chickennugget|n
chinchilla|n
chinolon|n
chloralken|n
chloraromat|n
chlorat|n
chlorid|n
chloridion|n
chlorit|n
chocolatier|m
cholin|n
chorizo|f
chromat|n
chromatid|n
chromosom|n
chronometer|n
chutney|n
ciabatta|f
cicerone|m
cidre|m
cis|n
citrat|n
citrin|m
city|f
clair-obscur|n
claqueur|m
clathrat|n
clavicula|f
clearing|n
cliché|n
cloud|f
clubbing|n
clutch|f
co₂|n
co2-steuer|f
co₂-steuer|f
coaching|n
cockpit|n
cocktail|m
cocktailbar|f
coda|f
code|m
codereview|m
coelestin|m
coenzym|n
coiffeur|m
cola|f
college|n
collier|n
coltan|n
come-back|n
comeback|n
coming-out|n
comingout|n
commenthur|m
commenthurey|f
communiqué|n
community|f
computergehäuse|n
computermaus|f
comthur|m
comthurey|f
connaisseur|m
conterfät|n
conterfei|n
conterfeit|n
conterfet|n
conterfeth|n
conterfey|n
contra|n
contrefei|n
copula|f
copyright|n
cornet|n
corona|f
coronavirus|n
corps|n
corpus|n
costüm|n
costüme|n
cottage|n
couch|f
couchsurfing|n
count-down-uhr|f
countdown-uhr|f
coupé|n
cousin|m
couvert|n
cover|n
coxa|f
cölestin|m
cranberry|f
credo|n
crêpe|m
crescendo|n
creutz|n
creuz|n
cringe|m
crwth|f
cue|m
cupcake|m
curcuma|f
curry|f
cuttermesser|n
cyanat|n
cyanid|n
cyanidion|n
cyclodextrin|n
cymbel|f
cystein|n
cystin|n
cytoblast|m
cytochrom|n
cytokin|n
d-mark|f
dach|n
dachreling|f
damastgewebe|n
damenuhr|f
dämonisieren|n
dampflok|f
danebenschiessen|m
dänin|f
danken|n
dankeschön|n
daransetzen|n
darmgeräusche|n
darts|n
darüberlegen|n
darüberliegen|n
dasein|n
dashboard|n
date|n
datenleck|n
datenreichtum|m
dating|n
datscha|f
dattel|f
dauer|f
daumendrücken|n
dauphin|m
daus|n
dba|n
debakel|n
debüt|n
deca|n
decan|n
dechsel|f
deck|n
deckmantel|m
deern|f
defensio|f
defilee|n
defizit|n
dehnungs-h|n
deichschart|n
deichsel|f
déjà-vu|n
deka|n
dekolleté|n
dekolletee|n
dekor|n
dekorateur|m
dekret|n
delfin|m
delikt|n
delir|n
delphin|m
delphinat|n
delta|n
dementi|n
demo|f
denkart|f
denkmal|n
denkmalschützen|n
denkungsart|f
denkzettel|m
deo|n
deodorant|n
deonym|n
deponens|n
depot|n
derby|n
derivat|n
derivatem|n
des|n
desaster|n
descloizit|n
deserteur|m
desiderat|n
design|n
dessert|n
dessous|n
detritivore|m
deuterid|n
deuteron|n
deutschkenntnis|f
devitalisationsmittel|f
dextrin|n
dezernat|n
dia|n
diadem|n
diakritikon|n
diapositiv|n
diarrhö|f
diarsan|n
diaspora|f
diät|f
dibenzodioxin|n
dibenzofuran|n
dichlorid|n
dichloroargentat|n
dichromat|n
dickicht|n
dickpic|n
dickschnabelpinguin|m
dicyanoargentat|n
diech|n
diensthaus|n
dienstleistungsgewerbe|n
dieselöl|n
diesseits|n
differential|n
differentialgetriebe|n
differenzial|n
differenzialgetriebe|n
diffgl.|f
difluorid|n
digitalisat|n
digitaluhr|f
diglycerid|n
dihydrat|n
diktat|n
dimer|n
diminutiv|n
diner|n
ding|n
dingens|n
dinner|n
dinucleotid|n
dinukleotid|n
dioxid|n
dioxyd|n
diphosphat|n
diphosphonat|n
diplom|n
diplomingenieur|m
diproton|n
dipsomane|m
diptychon|n
dirigat|n
dirndl|n
dis|n
disco|f
diselan|n
diselenid|n
disko|f
diskothek|f
diskurspartikel|n
display|n
dispositiv|n
diss.|f
distel|f
distiban|n
distichon|n
disulfan|n
disulfat|n
disulfid|n
disulfit|n
ditellurid|n
diterpen|n
dithiolan|n
dithionat|n
dithionit|n
dito|n
diva|f
divertikel|n
divis|n
dixi-klo|n
dixiklo|n
dock|n
dodecan|n
dogenpalast|m
doktorat|n
doktortitel|m
doku|f
domina|f
dompteur|m
domstift|n
donga|f
donnerkeil|m
dooring|n
dope|n
doppel|n
doppelhaus|n
doppelpack|m
doppelschwanz|m
doppelwohnhaus|n
dorf|n
dorftrottel|m
dormer-zwergfledermaus|f
dosenpfand|n
dosimeter|n
dossier|n
double|n
doublé|n
döneken|n
döner-box|f
dönneken|n
drachen|m
dragee|n
dragée|n
drangsal|f
draufgängertum|m
dreckloch|n
drecksau|f
drecksloch|n
drehtür|f
dreieck|n
dreirad|n
dreisprung|m
dreißig|f
dreissigeck|n
dreißigeck|n
dreiunddreißig|f
dreiundfünfzig|f
dreiundvierzig|f
dreiundzwanzig|f
dresseur|m
dressing|n
drift|f
drive|m
drossel|f
ds-gvo|f
dsgvo|f
dubbel|n
dublee|n
duck-typing|n
duckface|n
duell|n
duett|n
dult|f
dung|m
dunkelgrau|n
dunkelrot|n
duo|n
duopol|n
duplikat|n
dur|n
durchbläuen|n
durcheinander|n
durchlaucht|f
durian|f
duschgel|n
dutzend|n
dvd|f
dwz|f
dynamit|n
e-bike|n
e-book|n
e-form|f
e-rezept|n
e-werk|n
easteregg|n
eb|f
echo|n
echolot|n
eck|n
ecker|f
eckhaus|n
edel-uni|f
edelgas|n
edelweiss|n
edikt|n
edukt|n
effizienzmaß|n
efk|n
ego|n
ehegelübde|n
ehesteuer|f
ehr|f
ehrenamt|n
ei|n
eiben-art|f
eibenart|f
eichel|f
eichen-art|f
eichenart|f
eichenhain|m
eichenlaub|n
eider|f
eierklar|n
eierkuchen|m
eierkühlhaus|n
eierloch|n
eierpfannkuchen|m
eiertanz|m
eigelb|n
eigen|n
eigenart|f
eigengrau|n
eigenlob|n
eigent.-whg.|f
eigentor|n
eigt.-whg.|f
eiklar|n
eiland|n
einband|m
einbauteil|m
einbrenn|f
einfaltspinsel|m
einfamilienhaus|n
einfamilienwohnhaus|n
einfetten|n
einfrieden|n
einfuhr|f
eingangstür|f
eingeweide|n
einheitsbrei|m
einkaufsbeutel|m
einkaufswagerl|n
einkaufszettel|m
einkommen|n
einkommenssteuer|f
einkommensteuer|f
einkunft|f
einküchenhaus|n
einmaleins|n
einrad|n
eins|f
einschussloch|n
einsprengsel|n
einunddreißig|f
einundfünfzig|f
einundvierzig|f
einundzwanzig|f
einwand|m
einwegmesser|n
einwegpfand|n
einwohnermeldeamt|n
einzel|n
einzelverkauf|n
eis|n
eisen|n
eisenerz|n
eisenion|n
eisprung|m
eistee|m
eiweiss|n
eiweiß|n
ejakulat|n
ejalet|n
ekel|n
ekg|n
ekzem|n
elastomer|n
elbenkönig|f
elefantenlaus|f
elektroingenieur|m
elektron|n
elektroskop|n
elephantenlaus|f
elf|f
elfeck|n
elfin|f
elixier|n
ellipsoid|n
elsflether|m
elster|f
elternhaus|n
elternteil|m
elytron|n
em|f
email|f
embargo|n
emblem|n
emirat|n
empfängnis|f
empfangsgebäude|n
empire|n
enantiomer|n
enby|n
ende|n
endoskop|n
engerl|n
englischkenntnis|f
engramm|n
ensemble|n
entbindungstermin|m
ententanz|m
entgelt|n
entrecote|n
entree|n
entrée|n
entscheidungsbefugnis|f
entwicklungsvorsprung|m
enzyklika|f
enzym|n
eosin|n
episkopat|n
epitaph|n
epithel|n
epitheton|n
epos|n
epoxid|n
epsilon|n
erbgut|n
erbin|f
erbschaftssteuer|f
erbschaftsteuer|f
erdalkalimetallion|n
erdenrund|n
erdgas|n
erdmantel|m
erdnuß|f
erdnussöl|n
erdnußöl|n
erdöl|n
erdreich|n
erdteil|m
ereigniss|n
ergebniss|n
ergometer|n
erkenntnis|f
erkenntniss|f
erkenntniß|f
erklingen|n
erlaubnis|f
erlebniss|n
ersatzrad|n
erschwindeln|n
ersparnis|f
erwachsenenalter|n
erythem|n
erz|n
erzstift|n
es|n
es-dur|n
eselsohr|n
eselspinguin|m
espenlaub|n
essen|n
essmesser|n
eßzeug|n
eßzimmer|n
estin|f
eszett|n
eta|n
ether|n
ethoxylat|n
etikett|n
etui|n
etwas|n
euxenit|n
examen|n
exempel|n
exemplar|n
exemplifizieren|n
exfrau|f
exonym|n
experimentieren|n
explosimeter|n
exponat|n
exporteur|m
exportgut|n
exposé|n
exposee|n
externat|n
extranet|n
extrapolieren|n
extrem|n
exzerpt|n
exzisat|n
f*ck*n|n
f*cken|n
f*tz|f
f*tz*|f
fabel|f
fabrikat|n
fach|n
fächerschwanz|m
fachkenntnis|f
fachtrottel|m
fachwerkhaus|n
fackel|f
fagott|n
fahrenheit|n
fahrrad|n
fahrradmantel|m
fahrradsattel|m
fahrt|f
faible|n
fake|n
faktura|f
falafel|f
falbel|f
falchion|n
falltür|f
falsett|n
familienhaus|n
familienwohnhaus|n
family|f
fanal|n
fantakuchen|m
farad|n
farbbeutel|m
färberdistel|f
farm|f
faser|f
fass|n
faß|n
fasson|f
fastfood|n
fatamorgana|f
fatwa|f
fäulnis|f
fauna|f
faust|f
faustpfand|n
favela|f
fazit|n
feature|n
feder|f
federhaus|n
feedback|n
feeling|n
feh|n
feier|f
feitel|m
felchen|m
feld|n
feldmaus|f
feldrain|m
felgaufschwung|m
fell|n
fellatio|f
felsenpinguin|m
felsvorsprung|m
feminat|n
femtosekunde|m
fenn|n
fenster|n
fensterl|n
fentanyl|n
ferienhaus|n
ferkel|n
fermion|n
fernsehredakteur|m
fernweh|n
ferredoxin|n
ferritin|n
ferrocen|n
ferrochrom|n
ferromangan|n
ferroniob|n
fertighaus|n
fessel|f
fest|n
festgehalt|n
festival|n
feston|n
fett|n
fettgewebe|n
feuer|n
feuerleiter|f
feuerroß|n
feuerwehrhaus|n
feuilleton|n
ffg|n
fiasko|n
fibel|f
fiber|f
fiberglasgehäuse|n
fiberglasgewebe|n
fiberglaspinsel|m
fiberglasschaft|m
fidel|f
fieber|n
fieberthermometer|n
fiedel|f
fieder|f
fietsken|n
filet|n
filia|f
filigran|n
filmregisseur|m
filtrat|n
filzlaus|f
finale|n
finanzamt|n
finanztransaktionssteuer|f
fingerfood|n
finsternis|f
finta|f
fintieren|n
firewall|f
firlefanz|m
firma|f
firnis|m
fis|n
fischmesser|n
fistel|f
fitis|m
fitna|f
fitti|n
fixie|n
fixierbad|n
flächenmaß|n
flageolett|n
flak|f
flammkuchen|m
flaneur|m
flankerl|n
fledermaus|f
fleet|n
flehen|n
fleisch|n
fleischlaberl|n
fleischmesser|n
fleischpflanzerl|n
fleischpflanzl|n
flett|n
flex|f
fliegerass|n
flinta|f
flipflop|n
flora|f
florett|n
floskel|f
floss|n
flößen|n
flucht|f
flugabsagen|n
flugbenzin|n
flughöhe|m
fluid|n
flunder|f
fluorcarbon|n
fluorid|n
fluoridion|n
flur|m
flusstal|n
flußtal|n
flussufer|n
flußufer|n
flut|f
fluth|f
fluttor|n
flügelnuß|f
flüssiggas|n
flüssigkeitsmaß|n
fm|n
foc|n
fohlen|n
followen|n
folter|f
fondue|n
fonem|n
foodie|m
form|f
formans|n
format|n
formel|f
formiat|n
formular|n
forschungslabor|n
forsthaus|n
fort|n
fortbewegungsart|f
foto|n
fotofinish|n
foton|n
foul|n
foyer|n
fracht|f
fracking-gas|n
frackinggas|n
frackuhr|f
fraktal|n
framework|n
franchise|n
frankolin|m
franze|n
französischkenntnis|f
frau|f
frauenhaus|n
frauenstift|n
freibad|n
freio|n
freischwanzfledermaus|f
freistil|m
fremdbestandteil|m
fresko|n
freud|f
freudenhaus|n
friede|m
frikassee|n
frisbee|n
friseur|m
frist|f
frl.|n
fron|f
front|f
frontend|n
frontispiz|n
frontvorsprung|m
frotteur|m
frösteln|n
frucht|f
fruchtgenuss|m
früchtetee|m
frühlingsende|n
fuchsschwanz|m
fuchtel|f
fuder|n
fugen-s|n
fulleren|n
fulminat|n
fungizid|n
funke|m
funkloch|n
funkuhr|f
funzel|f
furcht|f
furnier|n
furt|f
fuselöl|n
fussangel|f
fußangel|f
fussel|f
fussnotenapparat|f
fussvolk|m
fut|f
futhark|n
futter|n
futteral|n
futtloch|n
future|m
fuzo|f
füllen|n
füllgas|n
füllsel|n
fünf|f
fünfeck|n
fünfgang-getriebe|n
fünfganggetriebe|n
fünfring|f
fünfunddreißig|f
fünfundvierzig|f
fünfundzwanzig|f
fünfzig|f
fünfzigeck|n
fürstenthumb|n
füttern|n
gabel|f
gacki|n
gadem|n
gaffel|f
gala|f
galápagos-pinguin|m
gallan|n
gallat|n
gallert|n
gamba|f
gambit|n
game|n
gameplay|n
gangart|f
gangklo|n
ganglion|n
gangrän|n
ganja|n
gans|f
gänsehautmoment|m
gänsemast|f
gaop|f
garagentor|n
gardemaß|n
garn|n
garnison|f
gartenanteil|m
gartenhaus|n
gartenrotschwanz|m
gas|n
gassi|n
gästehaus|n
gasthaus|n
gasuhr|f
gate|n
gateway|n
gatt|n
gatter|n
gauchheil|m
gaudi|n
gazpacho|f
geäfter|n
geäst|n
gebäck|n
gebälk|n
gebärde|f
gebärdensprache|f
gebäu|n
gebein|n
gebell|n
gebet|n
gebetsfahne|f
gebetsflagge|f
gebetsmühle|f
gebiet|n
gebiss|n
gebitt|n
geblüt|n
gebot|n
gebräu|n
gebrauchtware|f
gebresten|n
gebrumm|n
gebrüll|n
gebund|n
geburt|f
geburtenrate|f
geburth|f
geburtshaus|n
geburtstagskarte|f
geburtstagskuchen|m
geburtstagstorte|f
geburtsurkunde|f
gebühr|f
gebühreneinzugszentrale|f
gebüsch|n
gedächtnisloch|n
gedächtnislücke|f
gedächtniss|n
gedanke|m
gedankenblase|f
gedankenlesen|n
gedankenursprung|m
gedärm|n
gedeck|n
gedenkminute|f
gedenkmünze|f
gedenkstätte|f
gedicht|n
gedöns|n
geest|f
gefach|n
gefahr|f
gefahrenstufe|f
gefahrenzone|f
gefahrgut|n
gefährt|n
gefängniss|n
gefängnisstrafe|f
gefängniszelle|f
gefäss|n
gefäß|n
gefäßpflanze|f
gefecht|n
gefieder|n
gefild|n
geflecht|n
geflügel|n
gefrierbeutel|m
gefriertruhe|f
gefühl|n
gegacker|n
gegenanzeige|f
gegend|f
gegenexpertise|f
gegenion|n
gegenliebe|f
gegenmassnahme|f
gegenmaßnahme|f
gegenoffensive|f
gegenseite|f
gegentor|n
gegenwartssprache|f
gehaltsliste|f
gehäuseschnecke|f
geheimabsprache|f
geheimniss|n
geheimsprache|f
geheiß|n
geheul|n
gehirn|n
gehirnwäsche|f
gehirnwelle|f
gehirnzelle|f
gehminute|f
gehöft|n
gehölz|n
gehör|n
gehörn|n
gehschule|f
gehülfe|m
geierschildkröte|f
geige|f
geisel|f
geiselnahme|f
geisha|f
geiss|f
geiß|f
geissel|f
geißel|f
geissraute|f
geißraute|f
geisterhaus|n
geisterrad|n
gel|n
gelächter|n
gelackmeierte|f
gelage|n
geländer|n
geländestufe|f
gelass|n
geläut|n
gelb|n
gelbaugenpinguin|m
gelbbugamazone|f
gelbflügelamazone|f
gelbkopfamazone|f
gelbphase|f
gelbschulteramazone|f
geld|n
geld-brief-spanne|f
geldbeutel|m
geldbörse|f
geldbuße|f
geldkatze|f
geldmenge|f
geldmünze|f
geldseite|f
geldspende|f
geldstrafe|f
geldsumme|f
geleit|n
gelenk|n
gelichter|n
gelse|f
gelüst|n
gemach|n
gemächt|n
gemäuer|n
gemecker|n
gemeinde|f
gemeindebackhaus|n
gemeindehaus|n
gemeingut|n
gemeinschaftsaufgabe|f
gemeinschaftsküche|f
gemeinschaftswanne|f
gemeinsprache|f
gemengsel|n
gemetzel|n
geminipartus|n
gemisch|n
gemischtware|f
gemme|f
gemse|f
gemüsebrühe|f
gemüsekuchen|m
gemüsemesser|n
gemüseplatte|f
gemüsesauce|f
gemüsesorte|f
gemüsesosse|f
gemüsesoße|f
gemüsesuppe|f
gemüt|n
gemüth|n
gen|n
gender|n
generalgouverneur|m
generalprobe|f
generalstreik|m
genick|n
genie|n
genist|n
genital|n
genom|n
genpflanze|f
genschere|f
genus|n
geo|n
geodäte|f
geosphäre|f
gepäck|n
gepard|f
geplänkel|n
gequassel|n
gerät|n
geräusch|n
gericht|n
gerichtsurkunde|f
gerinnsel|n
german|n
germanat|n
germaniumerz|n
gernegross|m
geröll|n
gerste|f
gerstengrütze|f
gerte|f
gerücht|n
gerüst|n
ges|n
gesamtgehalt|n
gesamtgröße|f
gesamtkapitalrendite|f
gesamtmasse|f
gesamtmenge|f
gesamtschule|f
gesäss|n
gesäß|n
gesäßbacke|f
gesatz|n
geschäft|n
geschäftsausgabe|f
geschäftsreise|f
geschäftsstelle|f
geschehen|n
geschenk|n
geschichte|f
geschichtsquelle|f
geschirr|n
geschirrspülmaschine|f
geschlecht|n
geschoss|n
geschoß|n
geschossart|f
geschöpf|n
geschreibsel|n
geschütz|n
geschützfeuer|m
geschwader|n
geschwindigkeitsgrenze|f
geschwirr|n
geschwist|n
geschwister|n
geschwulst|f
geschwür|n
gesellschaftstanz|m
gesetz|n
gesicht|n
gesichtsbremse|f
gesichtsfarbe|f
gesichtsvorsprung|m
gesims|n
gespann|n
gespenst|n
gespenstschrecke|f
gespiele|m
gespinnst|n
gespinst|n
gespinstmotte|f
gespons|n
gespräch|n
gesprächspartikel|m
gesprächspause|f
gestade|n
gestalt|f
gestaltungsweise|f
geste|f
gesteck|n
gestein|n
gesteinsprobe|f
gestell|n
gestern|n
gestirn|n
gestöber|n
gestöhn|n
gesträuch|n
gestrüpp|n
gestühl|n
gestüpp|n
gestüt|n
gesuch|n
gesundheitsapostel|m
gesundheitsbehörde|f
getier|n
getränck|n
getränk|n
getränkekiste|f
getriebeglocke|f
getriebewelle|f
getto|n
getümmel|n
geviert|n
gewächs|n
gewächshaus|n
gewächshausgurke|f
gewalt|f
gewalttat|f
gewand|n
gewandhaus|n
gewäsch|n
gewässer|n
gewehr|n
geweih|n
gewerk|n
gewicht|n
gewichtsabnahme|f
gewichtsanteil|m
gewichtsklasse|f
gewichtsprozent|n
gewichtszunahme|f
gewindeloch|n
gewinnmarge|f
gewinnmitnahme|f
gewinnspanne|f
gewinnsteuer|f
gewirk|n
gewirr|n
gewissen|n
gewitter|n
gewitterwolke|f
gewöhnungssache|f
gewölk|n
gewusel|n
gewühl|n
gewürm|n
gewürz|n
gewürzgurke|f
gewürzmühle|f
gewürznelke|f
gewürzpflanze|f
gezänk|n
gezeit|f
gezelt|n
geziefer|n
gezücht|n
gezweig|n
gfrast|n
gfrieß|n
ggmbh|f
ghetto|n
ghusl|n
gicht|f
gießzettel|m
gif|n
gift|n
giftgas|n
gipfeli|n
girl|n
gis|n
gischt|f
gitarrensattel|m
gitter|n
gitterbox|f
gitzi|n
givebox|f
glanztat|f
glas|n
glasgebäude|n
glashaus|n
glastür|f
glaube|m
glaukom|n
glazial|n
glefenrad|n
gleichniss|n
gleis|n
gletschereis|n
glevenrad|n
glied|n
glioblastom|n
gliom|n
globin|n
globulin|n
glossar|n
glossem|n
glottis|f
gluconat|n
gluon|n
glut|f
glutamat|n
glutathion|n
gluten|n
gluth|f
glück|n
glücksklee|n
glücksrad|n
glycerid|n
glykogen|n
glykol|n
gmbh|f
gnat|f
gnu|n
goalie|m
goatee|m
gobelin|m
gogel|f
gold|n
golddistel|f
goldschopfpinguin|m
gollum|m
gondel|f
gondoliere|m
googol|n
gosch|f
goschen|f
goscherl|n
gotin|f
gotteshaus|n
gouverneur|m
gönnjamin|m
gör|n
gösch|f
gössel|n
gps|n
grab|n
grabmal|n
gracht|f
graf|n
grafem|n
graffiti|n
graka|f
gramm|n
grammofon|n
grammophon|n
granulat|n
grapefruit|f
graph|n
graphem|n
graphen|n
gras|n
grätzel|n
gräueltat|f
graupel|f
graveur|m
graviton|n
green|n
greencard|f
greueltat|f
griechische|n
griessbrei|m
grießbrei|m
grießkoch|n
grisperl|n
groko|f
groove|m
gros|n
groschen|m
gross|n
groß|n
großcousin|m
großstag|n
grossteil|m
großteil|m
größenersparnis|f
größenvorteil|m
grubenhaus|n
grubenotter|f
gruft|f
gruftie|m
grundart|f
grundbestandteil|m
grundel|f
grundgebirge|n
grundgehalt|n
grundkenntnis|f
grundsteuer|f
grunge|m
grün|n
grünpfeil|m
grüsch|n
gsg|f
gspusi|n
guasch|f
guckloch|n
guerilla|f
gugel|f
gulasch|n
gummiknittel|m
gummiknüttel|m
gummitwist|n
gurgel|f
gurkerl|n
gut|n
gutachten|n
guthaben|n
gült|f
gürtel|m
gwirks|n
gwop|n
gym|n
gymi|n
gyros|n
gyroskop|n
h|n
h-dur|n
haar|n
habitat|n
hacienda|f
hackenporsche|m
hadron|n
haferbrei|m
häferl|n
haff|n
haft|f
hagebuttentee|m
hahnenschrei|m
hahnrei|m
hakerl|n
halfter|n
halid|n
halleluja|n
hallenbad|n
hallenhaus|n
hallig|f
halloween|n
hallu|f
halluzinogen|n
halogen|n
halogenid|n
halon|n
häm|n
hämerythrin|n
hammelsprung|m
hammerclavier|n
hämocyanin|n
hamsterrad|n
hand|f
handbreit|f
handelsgut|n
handgemenge|n
handhaben|n
handicap|n
handout|n
handschaltgetriebe|n
handvoll|f
handy|n
handzettel|m
hanswurst|m
hantavirus|n
hantel|f
hanzi|n
hànzì|n
hapaxlegomenon|n
happening|n
happy-end|n
happyend|n
harakiri|n
haratin|m
hardcore|m
harmonika|f
harnleiter|f
hartlot|n
hartung|m
hartz-iv|n
harz|n
hasardeur|m
haschee|n
hascherl|n
haschischöl|n
hasel|f
haselmaus|f
haselnuß|f
haselnussöl|n
haselnußöl|n
häsin|f
haspel|f
hatz|f
haubenpinguin|m
haufe|m
haupt|n
häupt|n
hauptanteil|m
hauptbestandteil|m
hauptstag|n
hauptteil|m
hauptvorteil|m
haus|n
häus'l|n
hausanteil|m
hausbar|f
häuseken|n
häusel|n
hausflur|m
häusgen|n
häusken|n
häusl|n
häusle|n
hausmaus|f
hausrotschwanz|m
hauß|n
haustor|n
haustür|f
hauswurtz|f
haut|f
havanna|f
headset|n
heben|n
hechel|f
heck|n
hedging|n
heer|n
heft|n
heia|f
heiland|m
heilbad|n
heim|n
heimat|f
heimweh|n
heiopei|m
heirat|f
heirath|f
heiratsgut|n
heiratsschwindel|m
heizgewölbe|n
heizöl|n
hektar|n
heldentat|f
helge|m
heliometer|n
hellgrau|n
helling|f
hellrot|n
helvetier|m
hemd|n
hendiadyoin|m
hendl|n
henry|n
heptan|n
heptanol|n
herbeirufen|n
herbizid|n
herbstende|n
herbstlaub|n
herkunft|f
hermelin|n
herrenhaus|n
herrenuhr|f
hertz|n
hertzoginn|f
herumfahren|n
herumgammeln|n
herumhacken|n
herumlungern|n
hervorspringen|n
hervortreten|n
herwehen|n
herz|n
herzass|n
herzbeutel|m
herzkatheterlabor|n
herzklopfen|n
herzmuskelgewebe|n
herzoginn|f
herzweh|n
heterozygot|n
heu|n
heuer|f
heute|n
hexachloroplatinat|n
hexacyanoferrat|n
hexagon|n
hexan|n
hexanol|n
hexen|n
highlight|n
hilfsgut|n
himmelreich|n
himmelsleiter|f
himmelsreich|n
hin|n
hinauslaufen|n
hineinpassen|n
hinkel|n
hinkunft|f
hinterende|n
hinterhaus|n
hinterrad|n
hintertür|f
hinwehen|n
hippie|m
hiragana|n
hirn|n
hirschkuh|f
hirtentäschel|n
his|n
histamin|n
hitbox|f
hoatzin|m
hobby|n
hoch|n
hochära|f
hochgebirge|n
hochglanzmagazin|n
hochhaus|n
hochklappen|n
hochmoor|n
hochrad|n
hochsprung|m
hochstift|n
hockklo|n
hohlmaß|n
hohlraumresonator|n
holding|f
holdrio|n
hollandrad|n
holster|n
holtz|n
holz|n
holzfaß|n
holzgebäude|n
holzhammer|m
holzhaus|n
holzmesser|n
holztür|f
homburg|m
homograph|m
homolog|n
homonym|n
homophon|n
honigkuchen|m
honorar|n
hoodie|m
hoppala|n
hoppla|n
hormon|n
horn|n
hornerz|n
hornung|m
horoskop|n
hosengürtel|m
hosianna|n
hospital|n
hospiz|n
hostess|f
hosting|n
house|m
hox-gen|n
höchstalter|n
höhenruder|n
hps|f
huchen|m
huhn|n
humboldt-pinguin|m
hummel|f
hundefriseur|m
hundert|n
hundstrümmerl|n
hungersnot|f
hungerstreik|m
hurenhaus|n
huri|f
hurra|n
hustlen|n
hutschachtel|f
hutzel|f
hüftknochen|m
hühnerei|n
hühnerzüchten|n
hydrat|n
hydrauliköl|n
hydrazin|n
hydrid|n
hydridion|n
hydrochinon|n
hydronym|n
hydroxidion|n
hydroxyaldehyd|n
hydroxychinolin|n
hydroxychloroquin|n
hydroxylamin|n
hydroxylapatit|n
hygrometer|n
hype|m
hyperbaton|n
hyperbel|f
hyperon|n
hyperonym|n
hypobromit|n
hyponym|n
hypothek|f
hysto|f
i-tüpferl|n
ich|n
icon|n
id|n
ideal|n
idiom|n
idiotikon|n
idol|n
idyll|n
igelrochen|m
image|n
imageboard|n
imitat|n
immunglobulin|n
impala|f
imperfekt|n
implantat|n
importeur|m
inbox|f
incentive|n
indigo|n
indiumion|n
indiz|n
indol|n
inertgas|n
inferno|n
infix|n
info|f
infrarot|n
ingenieur|m
ingrediens|n
inkunabel|f
inland|n
inlett|n
innehaben|n
innendekorateur|m
innenohr|n
inschrift|f
insect|n
insekt|n
insektizid|n
insel|f
inserat|n
installateur|m
institut|n
instrukteur|m
integral|n
intensivieren|n
interaktom|n
interesse|n
interferon|n
interfix|n
interieur|n
interim|n
intermezzo|n
internat|n
internet|n
interrobang|n
intervall|n
interview|n
intifada|f
intranet|n
inventar|n
investmentfirma|f
inzucht|f
iod|n
iodat|n
iodid|n
iodthyronin|n
ion|n
iota|n
irdengut|n
irin|f
iris|f
irrenhaus|n
irrsal|n
irrthum|m
irrtum|m
isobar|n
isomer|n
isoton|n
isotop|n
ixel|n
ja|n
jabot|n
jacht|f
jackett|n
jagd|f
jagdmesser|n
jagertee|m
jagesage|n
jahr|n
jahresamt|n
jahresende|n
jahrhundertende|n
jahrzehnt|n
jakobsleiter|f
jamaika-aus|n
jar|n
jasmin|m
jaukerl|n
jausen|f
jawort|n
jeans|f
jecke|m
jein|n
jelängerjelieber|n
jenseits|n
jetzt|n
jingle|m
jo-jo|n
joch|n
jockei|m
jod|n
jodid|n
joke|m
jongleur|m
jorts|f
jot|n
jota|n
joule|n
journal|n
juckpulver|m
judenhaus|n
judensau|f
judenspanisch|n
judo|n
jugendalter|n
jugendamt|n
jugendgästehaus|n
jugendirresein|n
jugendstil|m
jukebox|f
jul|n
julei|m
jung|m
junge|m
jungfer|f
jungfernkranz|m
jungsband|f
junkie|m
junktim|n
junta|f
jury|f
justizirrtum|m
jüdin|f
jütin|f
kabarett|n
kabel|n
kabelmesser|n
kabinett|n
kabrio|n
kabuff|n
kabuki|n
kabyle|m
kachel|f
kadaverin|n
kaff|n
kaffee|m
kaffeehaus|n
kaffeepad|n
käfter|n
kahba|f
kainsmal|n
kaiserhaus|n
kaiserpinguin|m
kaiserreich|n
kajal|n
kaki|f
kalaschnikow|f
kalb|n
kälbermast|f
kaleidoskop|n
kali|n
kaliber|n
kalifat|n
kalorimeter|n
kameel|n
kamel|n
kamera|f
kamerafrau|m
kamikaze|m
kamillentee|m
kammer|f
kanapee|n
känguru|n
känguruh|n
kanin|n
kanji|n
kantineur|m
kanu|n
kanzel|f
kanzleramt|n
kap|n
kaper|f
kapital|n
kapitelhaus|n
kappa|n
kapsel|f
kar|n
karat|n
karate|n
karbonat|n
kardinale|n
karnickel|n
karnies|n
karo|n
karoass|n
karree|n
karriereende|n
karriereleiter|f
karriol|n
karsee|m
kartell|n
kartenhaus|n
kartoffel|f
kartoffelbrei|m
karussell|n
karzinom|n
käse|m
käsekuchen|m
käsemesser|n
kasino|n
kassa|f
kassava|f
kassawa|f
kassazettel|m
kassenzettel|m
kastell|n
kasterl|n
kastl|n
kaszettel|m
katakana|n
katana|n
kation|n
katzenklo|n
katzensprung|m
katzentür|f
kauderwelsch|n
kaufhaus|n
kaufmanns-und|n
kaufsorder|f
kausch|f
kautsch|f
kebab|n
kebab-box|f
kebap|n
keil|m
kellertür|f
kelter|f
kelvin|n
kendo|n
kenning|f
kennmal|n
kenntnis|f
kenntniss|f
kenntniß|f
kerngehäuse|n
kernöl|n
kerzenziehen|n
kesselhaus|n
keton|n
keuschheitsgürtel|m
keyboard|n
kfz|n
kgv|n
khanat|n
khmer|n
ki|f
kid|n
kiddie|n
kiefer|f
kiefern-art|f
kiefernart|f
kilo|n
kimm|f
kind|n
kinderkrankenhaus|n
kindermesser|n
kinderrad|n
kindesnot|f
kinn|n
kino|n
kipfel|n
kipfl|n
kippa|f
kippah|f
kirchengebäude|n
kirchenmaus|f
kirchensteuer|f
kirchentür|f
kirchenuhr|f
kirchweih|f
kirmes|f
kirschkuchen|m
kissen|n
kita|f
kittel|m
kitz|n
kiwi|f
klamm|f
klammer|f
klapper|f
klapperl|n
klappmesser|n
klapprad|n
klathrat|n
klaus|f
klausel|f
klavier|n
klavikel|n
klavikula|f
klebezettel|m
klei|m
kleid|n
kleiko|f
kleinod|n
klientel|f
kliff|n
klimakleber|m
klimastreik|m
klimax|f
klingel|f
klingeln|n
klingen|n
klischee|n
klitikon|n
klitoris|f
klo|n
klobassi|f
klosett|n
kloster|n
kluft|f
kluntje|n
kmu|n
knallgas|n
knappschaftskrankenhaus|n
knie|n
knigge|m
knittel|m
knochen|m
knochengewebe|n
knochenmark|n
knochentumor|f
knopfloch|n
know-how|n
knowhow|n
knüttel|m
kobra|f
kochmesser|n
koda|f
kode|m
koenzym|n
kogel|f
kohyponym|n
koka|f
kokain|n
kokos|n
kokosnuß|f
kokosnussöl|n
kokosnußöl|n
kokosöl|n
kollaborateur|m
kollagen|n
kollar|n
kolleg|n
kollektiv|n
kollier|n
kolloid|n
kolon|n
kolorit|n
kolumnentitel|m
kombinat|n
komitee|n
kommandeur|m
kommando|n
komment|m
kommentur|m
kommissariat|n
kommodore|m
kommunikee|n
kommuniqué|n
komplet|n
komplexion|n
kompost|m
kompott|n
kompromat|n
komtur|m
kon|f
kondensat|n
kondom|n
kondukteur|m
konfekt|n
konfetti|n
konfi|f
konfix|n
konglomerat|n
konjunkturabschwung|m
konjunkturaufschwung|m
konklave|n
konkordat|n
konkubinat|n
konnektiv|n
konstrukteur|m
konsum|m
konsumgut|n
konterfei|n
kontingent|n
konto|n
kontor|n
kontra|n
kontrollbox|f
kontrolleur|m
kontrolluhr|f
konvikt|n
konvolut|n
konzentrat|n
konzept|n
konzert|n
konzerthaus|n
kopfgrind|m
kopflaus|f
kopfnuß|f
koppel|f
kopula|f
kor|m
kora|f
korallenotter|f
korallenriff|n
kordel|f
korn|n
kornett|n
korollar|n
korona|f
korporale|n
korps|n
korselett|n
korsett|n
kortholt|n
kortikoid|n
kosmodrom|n
kostüm|n
kotelett|n
kölsch|n
kölschkranz|m
königreich|n
königspinguin|m
körndl|n
körpermaß|n
körperschaftssteuer|f
körperschaftsteuer|f
köttel|m
kptbs|f
krachen|m
kracherl|n
krad|n
krafft|f
kraft|f
kraftrad|n
krähwinkel|n
krampfader|f
krankenhaus|n
kranz|m
kratzdistel|f
kraut|n
kräutertee|m
kreateur|m
krebsart|f
krem|f
kreol|n
kreosot|n
kreutz|n
kreuz|n
kreuzass|n
kreuzgewölbe|n
kreuzgratgewölbe|n
kreuzotter|f
kreuzrippengewölbe|n
kriegsende|n
kriegslist|f
kriminalamt|n
kripo|f
kristallgefüge|n
kronenpinguin|m
krösken|n
kruzifix|n
krügel|n
krypta|f
kryptonion|n
ksg|n
kuchen|m
kuchenmesser|n
kuckucksei|n
kuckucksuhr|f
kufija|f
kufiya|f
kugel|f
kuh|f
kuhdung|m
kuhnasenrochen|m
kukumer|f
kuller|f
kulturbeutel|m
kulturgut|n
kumquat|f
kumt|n
kunkel|f
kunst|f
kunstsammeln|n
kunststoffanteil|m
kunststoffbeutel|m
kunststoffmesser|n
kupee|m
kupfererz|n
kuppel|f
kurant|n
kurbad|n
kurbel|f
kurhaus|n
kurkuma|f
kurssprung|m
kurzhantel|f
kuttel|f
kuvert|n
küchen|f
küchenmesser|n
küchentür|f
kücken|n
küfa|f
kühlbox|f
kühlgut|n
kühlhaus|n
küken|n
kündigungsfrist|f
kündigungswelle|n
künsteley|f
kür|f
kürzel|n
küssen|n
kymation|n
kz|n
lab|n
label|n
labor|n
laborkittel|m
labormaus|f
labsal|n
labskaus|n
labyrinth|n
lächeln|n
lachyoga|n
lackerl|n
lacrosse|n
lactat|n
ladentür|f
lady|f
lagemaß|n
lager|n
lagerhaus|n
laiin|f
laissez-faire|n
laken|n
lambda|n
lamina|f
laminat|n
lamm|n
lämmerschwanz|m
land|n
landauer|m
landei|n
landgut|n
landhaus|n
landratsamt|n
landsee|m
landtagsgebäude|n
längenmaß|n
langhantel|f
langschwanzpinguin|m
lanthanoid|n
lärchen-art|f
lärchenart|f
larifari|n
last|f
latschen|m
laub|n
laufhaus|n
laufrad|n
laufuhr|f
laufzettel|m
laus|f
läuseei|n
lausei|n
lava|f
lavabo|n
lavash|n
lawash|n
lawra|f
layout|n
lazarett|n
leben|n
lebensader|f
lebensalter|n
lebensart|f
lebensende|n
lebensstil|m
leber|f
leberegel|m
lebkuchen|m
lebkuchenhaus|n
lechzen|n
leck|n
led|f
leder|n
ledergürtel|m
ledermantel|m
leergut|n
legat|n
legierungsbestandteil|m
lehen|n
lehmhaus|n
lehramt|n
leiberl|n
leichenhaus|n
leichenschauhaus|n
leid|n
leiden|n
leier|f
leierschwanz|m
leihfrist|f
leihhaus|n
leilach|n
leinen|n
leinsamenöl|n
lektin|n
lemniskate|f
lenz|m
leo|n
lepton|n
lernstil|m
lesart|f
lesbier|m
letter|f
leuchtgas|n
leucin|n
leukotrien|n
lewisit|n
lexem|n
lexikon|n
leyd|n
liaison|f
libera|f
libretto|n
licht|n
lichtspielhaus|n
lid|n
lidocain|n
liebesweh|n
lied|n
liederkranz|m
liegerad|n
liesch|n
liga|f
lignin|m
limit|n
limo|f
limoncello|m
lindauer|m
lindenblütentee|m
lineal|n
linksgewinde|n
linnen|n
lipid|n
liquida|f
list|f
listeria|f
litewka|f
lithiumamalgam|f
lithiumion|n
litotes|f
litschi|f
lng|n
lob|n
lobby|f
loch|n
lodz|n
log|n
logfile|n
loggia|f
lohnart|f
lohngefälle|n
lohnsteuer|f
lok|f
lokal|n
lokalredakteur|m
lokalteil|m
lootbox|f
lorbeer|m
lorbeerkranz|m
lorchel|f
los|n
lot|n
loth|n
lotterielos|n
lotto|n
löft|n
löllingit|n
löwenanteil|m
löwin|f
lpg|f
lra|n
lsd|n
luch|n
lucht|f
luder|n
luft|f
luftloch|n
lulu|n
luminometer|n
lunchbox|f
lungengewebe|n
lust|f
lustspielhaus|n
lux|n
luxusgut|n
luxusrestaurant|n
luxussteuer|f
lügen|f
lv|f
lyra|f
lysosom|n
m*sch*|f
m*schi|f
maar|n
maas|n
macadamianuß|f
macaron|n
machart|f
macht|f
machtgefälle|n
macron|n
mädchenhaus|n
mädel|n
mädle|n
madrasa|f
madrigal|n
maffia|f
mafia|f
magazin|n
magd|f
mage|m
magellan-pinguin|m
magenweh|n
maggi|n
magistra|f
magnesiumion|n
magnetron|n
magnum|f
mahd|f
mahl|n
mahnmal|n
maid|f
maiensäß|n
mailbox|f
maitli|n
majo|f
majolika|f
majuskel|f
make-up|n
makramee|n
makro|n
makron|n
mal|n
malheur|n
malz|n
mama|f
mamba|f
mami|f
mammut|n
mamsell|f
mandala|n
mandarin|m
mandat|n
mandel|f
mandelöl|n
mandibel|f
mandioka|f
mandola|f
mandorla|f
manganat|n
manganerz|n
manganocen|n
mango|f
mangold|m
manier|f
manko|n
männeken|n
mannequin|n
mannsschild|m
manometer|n
manöver|n
mantarochen|m
mantel|m
mantelplume|m
mantilla|f
mantra|n
manual|n
manx|n
mär|f
maraca|f
maracuja|f
mare|n
margell|f
margherita|f
marienbad|n
mariendistel|f
marinestützpunkt|f
marjell|f
mark|f
marktabschwung|m
marktanteil|m
marktaufschwung|m
marmel|f
marmorkuchen|m
marodeur|m
maroni|f
marroni|f
marshmallow|n
marter|f
martingal|n
mascara|f
maser|f
maskara|f
mass|n
maß|n
massai|n
massaker|n
massanzug|n
massel|f
massenanteil|m
massenmarketing|n
massenprozent|n
masseprozent|n
masseur|m
massiv|n
massschneidern|n
maßschneidern|n
mast|f
mastek|f
mastermind|n
mastodon|n
mastsau|f
masurka|f
material|n
matriarchat|n
matrikel|f
matrioschka|f
matrix|f
matrjoschka|f
matroschka|f
matt|n
matura|f
mauer|f
mauervorsprung|m
maul|n
maus|f
mauscheln|n
mauseloch|n
mäuseloch|n
mauser|f
mauserl|n
mausohr|n
mauspad|n
mauß|f
mausschwanzfledermaus|f
maut|f
mayo|f
mazurka|f
mda|n
mde|f
medaillon|n
medi|n
media|f
medicane|m
medina|f
meer|n
meeting|n
megafon|n
megalograph|m
megaphon|n
mehl|n
mehrfamilienhaus|n
mehrfamilienwohnhaus|n
mehrwegpfand|n
meitschi|n
melanom|n
melanzani|f
meldezettel|m
melken|n
melkkuh|f
mem|n
membran|f
meme|n
memo|n
memory|n
ménage-à-trois|f
mengsel|n
menora|f
menorah|f
mensa|f
mensch|n
menschenkenntnis|f
menthol|n
menuett|n
menü|n
mercaptan|n
mercedes-benz|m
meristem|n
merkmal|n
meson|n
messaging|n
meßbuch|m
messie|m
messuhr|f
meßuhr|f
mesusa|f
metall|n
metallanteil|m
metallfaß|n
metallion|n
metallmesser|n
metallocen|n
metalloid|n
metallteil|m
metapher|f
methamphetamin|n
metier|n
metonym|n
metro|f
metronom|n
metteur|m
mezzotinto|n
mg|n
mieder|n
mieten|n
mietlager|m
mietshaus|n
mifepriston|n
mikro|n
mikrofon|n
mikromol|n
mikrophon|n
mikroskop|n
mikrowellenfilter|n
milch|f
milchbar|f
milchkuh|f
milchshake|m
milieu|n
militärgouverneur|m
miliz|f
millikelvin|n
milz|f
mimin|f
minarett|n
mindestalter|n
mindestkenntnis|f
mindestmaß|n
mindestspeicherfrist|f
mindmap|f
mineral|n
mineralöl|n
mineur|m
minna|f
minus|n
mio|f
mirakel|n
mispel|f
miss|f
miß|f
missal|n
missetat|f
missraten|n
mistel|f
mitabstimmen|n
mitbringsel|n
mitfühlen|n
mitgift|f
mitochondrion|n
mitra|f
mitropa|f
mittelfußknochen|m
mittelgebirge|n
mittelmaß|n
mittelohr|n
mitzwa|f
mobile|n
mobiliar|n
mocktail|m
model|n
modell|n
modul|n
mofa|n
mohnflesserl|n
mohnkuchen|m
mokassin|m
mol|n
molder|f
molekül|n
moll|n
molotow-cocktail|m
molotowcocktail|m
molter|f
molybdänerz|n
molybdat|n
molybdation|n
molybdopterin|n
mom|f
moment|m
monatsende|n
mondamin|n
mondfinsternis|f
monoid|n
monokel|n
monom|n
monopol|n
monster|n
monteur|m
moor|n
moos|n
moped|n
mopped|n
mopsfledermaus|f
mora|f
moral|f
moralapostel|m
morchel|f
moritat|f
morphem|n
mosaik|n
motiv|n
motorfuchsschwanz|m
motorola|n
motorrad|n
mottenschildlaus|f
motto|n
mountainbike|n
mowl|n
möbel|n
mörtel|m
mp|f
mpox|n
mpu|f
mudda|f
muffin|m
mufflon|n
mulder|f
muli|n
mulle|m
multer|f
multifunktionsuhr|f
multikulti|n
mum|f
mummel|f
mummenschanz|m
mumu|f
mundart|f
mundloch|n
mundteil|m
mural|n
murmel|f
musche|m
muschel|f
muschi|f
muschilecken|n
musical|n
musikantenknochen|m
musikbox|f
muskatnuß|f
musketier|m
muslima|f
muss|n
muß|n
musselin|m
must-have|n
muster|n
muta|f
mutagen|n
mutmassen|n
mutmaßen|n
mutter|f
mutterkuchen|m
mutterlauge|f
muttermal|n
mutti|f
mutwille|m
mückenspray|n
müesli|n
mühlrad|n
mühsal|f
müllbeutel|m
mündel|f
müsli|n
mva|f
my|n
myokard|n
myon|n
myzel|n
n-gramm|n
nachbarhaus|n
nachen|m
nachfühlen|n
nachhut|f
nachkommaanteil|m
nachricht|f
nacht|f
nachteil|m
nachtheil|m
nachtigall|f
nachtshopping|n
nachweisreagenz|n
nachwuchstalent|n
nackedei|m
nacktwandern|n
nadel|f
nadelöhr|n
nagen|n
nahrungsbestandteil|m
naht|f
namaste|n
name|m
namensursprung|m
namibier|m
nanobot|n
nanopartikel|n
nantucket-rot|n
napfkuchen|m
nappa|n
narrativ|n
näscher|n
nasenloch|n
natriumdampflicht|n
natronfeldspat|n
natter|f
naturell|n
naturtalent|n
navi|n
nebengebäude|n
nebennierenmark|n
necessaire|n
nécessaire|n
negativ|n
negligé|n
négligé|n
negligee|n
nein|n
nervengas|n
nerverl|n
nessel|f
nessessär|n
nest|n
nestel|f
nettogehalt|n
netz|n
netzteil|m
neun|f
neuneck|n
neununddreißig|f
neunundsechzig|f
neunundvierzig|f
neunundzwanzig|f
neuroektoderm|n
neuroendokrinologe|m
neuroethologe|m
neuron|n
neutrino|n
neutron|n
newton|n
ngo|f
nibble|n
nichtmehraufhörenkönnen|n
nichts|n
nickelin|m
niederkunft|f
niederlegen|n
niederrad|n
nierenversagen|n
nike|m
nilkrokodil|m
niobat|n
niss|f
nitrat|n
nitrid|n
nitrit|n
niwo|n
njet|n
no-go|n
nockerl|n
nokia|n
nomen|n
non|f
nonagon|n
nonan|n
nonanol|n
nonnenfürzle|n
nonplusultra|n
norm|f
normal|n
normaluhr|f
normanne|m
not|f
notebook|n
notepad|n
noth|f
notierungssprung|m
notiz|f
notopleure|m
noumenon|n
nps|f
nucleotid|n
nudel|f
nukleon|n
nukleotid|n
nuklid|n
null|f
nullenergiehaus|n
numeral|n
numerale|n
nummer|f
nurdachhaus|n
nuss|f
nuß|f
nut|f
nüster|f
ny|n
nylon|n
o-bein|n
obdach|n
oberende|n
oberhaus|n
obers|n
obersattel|m
oberschenkelknochen|m
obfrau|f
objekt|n
objektiv|n
oblast|f
obligo|n
obst|n
obstkuchen|m
obstmesser|n
octan|n
octanol|n
octen|n
oeuvre|n
œuvre|n
office|n
ogonek|n
ohr|n
ohrloch|n
ohropax|n
ohrwaschel|n
okapi|n
okarina|f
okra|f
oktan|n
oktett|n
olefin|n
oligopol|n
olivenhain|m
olivenöl|n
olivin|m
olympiastadion|n
oma|f
omega|n
omelett|n
omen|n
omi|f
omikron|n
onigiri|n
onus|n
oper|f
operateur|m
opernhaus|n
opfer|n
opiat|n
opus|n
orakel|n
orangeat|n
orangenhain|m
orbital|n
orchester|n
order|f
ordinale|n
ordnungsamt|n
oreganoöl|n
organ|n
organophosphin|n
organversagen|n
orgel|f
orgon|n
origami|n
original|n
orthogon|n
ortsteil|m
os|n
osterei|n
ostern|n
oszilloskop|n
otoskop|n
oud|f
ouija|n
oukie|m
out|n
outcome|n
outdoor|n
outfit|n
oval|n
ovar|n
oxalat|n
oxid|n
oxidion|n
oxin|n
oxoniumion|n
oxyd|n
oxygen|n
oxymoron|n
oxytonon|n
ozonid|n
ozonidanion|n
ozonloch|n
ödem|n
ödland|n
ödnis|f
öffi|n
öhr|n
öl|n
ölauge|n
ölbild|n
ölfass|n
ölfaß|n
ölfeld|n
ölgemälde|n
öllobby|f
ölsaat|f
öre|n
östrogen|n
p*nis|m
paar|n
pacht|f
pack|n
packeis|n
packerl|n
packgas|n
packhaus|n
paddel|n
paderborner|n
pädken|n
pak|f
paket|n
palais|n
palankin|m
palaver|n
palindrom|n
palliativ|n
palmöl|n
pampa|f
pamphlet|n
panaché|n
panaschee|n
pancake|m
paneel|n
panel|n
panier|n
pankreas|n
pannekuchen|m
pantheon|n
pantscherl|n
panz|m
paparazza|f
papaya|f
paper|n
papier|n
papierbeutel|m
pappel|f
pappmaché|n
pappmaschee|n
pappschachtel|f
parabel|f
paradeis|n
paradiddle|m
paradies|n
paradiesnuß|f
paradox|n
paradoxon|n
paraffin|n
paraffinöl|n
paralipomenon|n
paranoia|f
paranuß|f
paranussöl|n
paranußöl|n
parfüm|n
parkett|n
parkhaus|n
parkuhr|f
parlamentsgebäude|n
paroli|n
paronym|n
paröke|m
parsec|n
parterre|n
partezettel|m
partikel|f
partizip|n
party|f
partyband|f
pascal|n
paspel|f
passiv|n
pasta|f
pastell|n
patchwork|n
patella|f
patent|n
patentamt|n
paternoster|n
path.|f
pathos|n
patiens|n
patin|f
patina|f
patronym|n
patronymikon|n
patschen|m
patt|n
pav|n
paywall|f
pb|n
pech|n
pedal|n
pedalo|n
pedelec|n
pein|f
pekannuß|f
pekari|n
peloton|n
pelzmantel|m
pendant|n
pendel|n
pendeltür|f
pendeluhr|f
penis|m
penisknochen|m
penizillin|n
pennal|n
pensionat|n
pentagon|n
pentan|n
pentanol|n
penten|n
penthaus|n
penthouse|n
peperoni|f
pepsin|n
peptid|n
perfekt|n
periastron|n
perihel|n
perikard|n
periskop|n
perispomenon|n
peroxisom|n
perpendikel|n
persenning|f
person|f
personal|n
peschmerge|m
pest|f
pestizid|n
petschaft|n
petting|n
petzen|n
pfadi|f
pfaltz|f
pfalz|f
pfänden|n
pfandhaus|n
pfannekuchen|m
pfannkuchen|m
pfarrhaus|n
pfefferkuchen|m
pfefferminzöl|n
pfefferminztee|m
pfeffernuß|f
pfefferoni|f
pfeiferl|n
pfeil|m
pferd|n
pferdesattel|m
pferdeschwanz|m
pfingsten|n
pflanzenart|f
pflanzengewebe|n
pflanzenöl|n
pflaster|n
pflaumenkuchen|m
pflicht|f
pfropfer|m
pfund|n
pfuschzettel|m
pgh|f
phalanx|f
phantom|n
pharm.|f
pharmakon|n
phenakistiskop|n
phenanthrolin|n
phenol|n
pheromon|n
phi|n
philippika|f
philo|n
phishing|n
phloem|n
pho|f
phonem|n
phonetiksystem|f
phosphan|n
phosphat|n
phosphazen|n
phosphid|n
phosphin|n
phosphinat|n
phosphit|n
phosphonat|n
phosphorit|n
photo|n
photon|n
phrasem|n
physalis|f
phytat|n
pi|n
piano|n
pickerl|n
picknick|n
pidgin|n
piedestal|n
piefke|m
piercing|n
pietà|f
pik|n
pik-ass|n
pikass|n
pikkolo|n
pilates|n
pils|n
pilzart|f
pinakel|n
pinakol|n
pinakothek|f
piñata|f
pinguin|m
pink|n
pion|n
pique|n
pirsch|f
pissoir|n
pistol|n
pixel|n
pizza|f
pizzeria|f
pj|n
placebo|n
plädoyer|n
plagiat|n
plaid|n
plakat|n
pläsier|n
plastbeutel|m
plastebeutel|m
plastegehäuse|n
plastemesser|n
plastgehäuse|n
plastikbeutel|m
plastikmesser|n
plastikschwanz|m
platinerz|n
platinoid|n
platt|n
play-off|n
playlist|f
plazebo|n
plazenta|f
pleitier|m
plektron|n
plenk|n
plissee|n
plumpsklo|n
plus|n
plusenergiehaus|n
pluviale|n
pm|f
podest|n
poem|n
pokémon|n
polin|f
polis|f
polka|f
polster|n
polyethylen|n
polygon|n
polykül|n
polymer|n
polymerisat|n
polynom|n
polyolefin|n
polypropylen|n
polyptychon|n
polysem|n
polysulfan|n
polysyndeton|n
polytop|n
pomelo|f
pommes|f
pop-up|n
popanz|m
popcorn|n
porphyrin|n
porree|m
porrei|m
portal|n
portefeuille|n
portemonnaie|n
portepee|n
portfolio|n
portier|m
portmonee|n
portrait|n
porträt|n
porzellan|n
posament|m
poseur|m
positron|n
post|f
postamt|n
poster|n
postillion|m
postulat|n
potential|n
potentiometer|n
potenzial|n
potpourri|n
pottsau|f
poulet|n
präambel|f
präantepänultima|f
pracht|f
prachtstaffelschwanz|m
prädicat|n
prädikat|n
prädikativ|n
praeantepaenultima|f
praeteritio|f
präfix|n
präfixoid|n
praliné|n
pralinee|n
präparat|n
präpositionalgefüge|n
präriehund|n
präsens|n
präsent|n
präservativ|n
praxis|f
predigt|f
preisausschreiben|m
prekariat|n
pressehaus|n
presslufthammer|m
prestige|n
prima|f
primadonna|f
primel|f
primiz|f
princip|n
prinzgemahl|m
prinzip|n
prio|f
prion|n
priorat|n
privatier|m
privileg|n
probeabo|n
problem|n
procedere|n
produkt|n
profess|f
profeß|f
profiteur|m
projekt|n
prokonsulat|n
prokura|f
proletariat|n
promille|n
pronom|n
propanol|n
prophetengefährte|m
propionat|n
prostata|f
proteid|n
protein|n
protektorat|n
protokoll|n
proton|n
protozoon|n
provinz|f
provokateur|m
prozedere|n
prozent|n
prüfungstermin|m
pseudogetreide|n
pseudonym|n
pseudoskorpion|m
psi|n
pud|n
pudding|m
puffotter|f
pulk|n
pulsader|f
pult|n
pulver|n
pulverfaß|n
puma|m
pumpgun|f
puppenhaus|n
purpurgrackel|f
puschen|m
pustel|f
puzzle|n
pülleken|n
püree|n
pütz|f
pyrazin|n
pyroskop|n
pyrrhotin|m
pyrrol|n
pyruvat|n
pyxis|f
pzb|f
qrs|n
quaddel|f
quadrat|n
quadriga|f
qual|f
quali|f
qualifikationsrund|f
quant|n
quantensprung|m
quarta|f
quartal|n
quartett|n
quarzuhr|f
qubit|n
quecksilberthermometer|n
queen|f
quellensteuer|f
quermaß|n
quest|f
quickie|m
quinoa|f
quinta|f
r-gespräch|n
raa|f
rachen|m
racket|n
rackett|n
raclette|n
rad|n
radikal|n
radikalion|n
radio|n
radl|n
radlermaß|f
raffinat|n
ragout|n
rah|f
rahnock|f
rakel|f
raketentestgelände|n
rakett|n
rampensau|f
ranch|f
ranckett|n
ranelat|n
ranken|n
rankett|n
rapsöl|n
rapunzel|f
rasiermesser|n
rasierpinsel|m
raspel|f
raspelhaus|n
rasputiza|f
rassel|f
rast|f
raster|n
ratatouille|n
rathaus|n
rathhaus|n
räthsel|n
rationalisieren|n
rätsel|n
rattenschwanz|m
raummaß|n
raummeter|n
raumnot|f
rauschrot|n
rautenkranz|m
rautenkreuz|m
rave|m
razemat|n
razzia|f
reagenz|n
reala|f
realisat|n
reality-tv|n
reaumur|n
recept|n
rechen|m
rechnermaus|f
recht|n
rechteck|n
rechthaben|n
rechtsgewinde|n
recitativ|n
reck|n
redakteur|m
redensart|f
redeteil|m
reeling|f
reep|n
reet|n
ref.|f
referat|n
referee|m
reff|n
reform|f
refrain|m
regal|n
regel|f
regenbogenboa|f
regenbogentrikot|m
regenmantel|m
reggae|m
regime|n
regio|f
regisseur|m
register|n
reh|n
reha|f
rehabilitieren|n
reherl|n
reibekuchen|m
reiben|n
reich|n
reichthum|m
reichtum|m
reiheneckhaus|n
reihenhaus|n
reihenmittelhaus|n
reindl|n
rekommandeur|m
rektorat|n
relais|n
release|n
reli|n
relief|n
relikt|n
reling|f
reliquiar|n
remake|n
remis|n
ren|n
rendezvous|n
rennen|n
rennmaus|f
rennrad|n
renommee|n
rentenalter|n
renteneintrittsalter|n
rep|n
reparaturseidl|n
repertoire|n
repräsentantenhaus|n
requiem|n
requisit|n
reservat|n
reserverad|n
reservoir|n
resignieren|n
resort|n
ressort|n
restaurant|n
resultat|n
resümee|n
retabel|n
retardarzneimittel|f
retardationsfaktor|f
retardationskoeffizient|f
retardiermittel|f
retardierungsfaktor|f
retardierungsmittel|f
retardierungssyndrom|m
retina|f
retroflex|m
retronym|n
revers|n
revier|n
review|f
rezept|n
rezidiv|n
rezitativ|n
rhinozeros|n
rhizom|n
rho|n
rhodamin|n
rhodanid|n
rhodinieren|n
rhodiumion|n
rhomboid|n
ribisel|f
ribiselkuchen|m
ribosom|n
ried|n
ries|n
riesenrad|n
riff|n
rikscha|f
rind|n
rindermast|f
ringautobahn|m
ringerl|n
rinnsal|n
risibisi|n
risiko|n
risipisi|n
rittergut|n
ritual|n
ritzel|n
rivier|n
rizin|n
roadmap|f
robot|f
robotaxi|n
roche|m
rochen|m
rockband|f
rohöl|n
rohr|n
rohrdommel|f
rohstoffanteil|m
rollo|n
romni|f
rondell|n
rootkit|n
rosa|n
rosenkranz|m
rosinenkuchen|m
ross|n
roß|n
rot|n
rotaprint|f
rotgültigerz|n
roth|n
rothschild|m
rotschwanz|m
rotstirn-borstenschwanz|m
rouge|n
roulett|n
roulette|n
royalty|n
röhren|n
röhrenblattlaus|f
röhricht|n
röntgen|n
rössel|n
rösti|f
rötel|m
rpzb|f
rubbellos|n
rubidiumuhr|f
rubiklin|m
rudel|n
ruder|n
ruhestandsalter|n
ruhr|f
rumgammeln|n
rumlungern|n
rund|n
rundbogenstil|m
rundell|n
runkel|f
runzel|f
russenmagazin|n
rußpartikel|n
ruthenat|n
rutheniridosmin|m
rübli|n
rückentwickeln|n
rückgrat|n
rücksprung|m
rüebli|n
rührei|n
rührkuchen|m
rüster|f
rz|n
s-bahn|f
s-boot|n
saaltür|f
saat|f
sabbeln|n
sabbern|n
sabotieren|n
saccharid|n
sachet|n
sachkenntnis|f
sächseln|n
sacken|n
sackerl|n
sackloch|n
sackmesser|n
säen|n
safari|f
safflorit|n
saften|n
sägemesser|n
sahnen|n
saiga|f
saison|f
sake|m
sakralisieren|n
sakrileg|n
salak|f
salami|f
salär|n
salatbar|f
salatmesser|n
salatöl|n
salbeitee|m
salben|n
saldieren|n
salettl|n
salutieren|n
salz|n
salzamt|n
salzen|n
salzlauge|f
salzsee|m
salzstangel|n
salzstangerl|n
same|m
samin|f
samosa|n
sandbox|f
sandfelchen|m
sanduhr|f
sanieren|n
sanktionieren|n
sarde|m
sashimi|n
sattel|m
satteln|n
satthaben|n
sättigen|n
sattsehen|n
satzende|n
satzgefüge|n
sau|f
säubern|n
säuern|n
sauerstoffanteil|m
sauerstoffbar|f
sauerstoffion|n
saufen|n
saufgelage|n
saugen|n
säugen|n
säulenschaft|m
säumen|n
saumsattel|m
sauna|f
saunen|n
saunieren|n
säuseln|n
sausen|n
sautieren|n
saven|n
saxofon|n
saxophon|n
sb|f
scannen|n
schaar|f
schabmesser|n
schabsel|n
schach|n
schacht|m
schachtel|f
schachuhr|f
schade|m
schädelknochen|m
schaf|n
schaff|n
schaffel|n
schafott|n
schall-loch|n
schaller|f
schallloch|n
schamba|f
schandmal|f
schandmantel|m
schandpreis|n
schandtat|f
schandurteil|m
schandzeichen|f
schar|f
scharmützel|n
scharnier|n
schätzel|n
schatzerl|n
schau|f
schaufel|f
schaukel|f
scheibenbremssattel|m
scheißdreck|m
scheißhaus|n
scheitel|m
scheitholt|n
schekel|m
schenkelklopfer|m
schermaus|f
scherzel|n
scherzo|n
scheuer|f
scheunentor|n
scheusal|n
schibboleth|n
schicht|f
schicksal|n
schiebetür|f
schiefergas|n
schiefergrau|n
schieferöl|n
schießen|n
schiff|n
schiffsheck|n
schild|n
schildlaus|f
schilf|n
schinakel|n
schindel|f
schischa|f
schl*mp*|f
schlachthaus|n
schlafengehen|n
schlagader|f
schlager|m
schlagloch|n
schlamm|m
schlampensau|f
schlappschwanz|m
schlaufon|n
schleier|m
schlepptau|n
schleuder|f
schleudern|n
schleusenthor|n
schleusentor|n
schlitzohr|n
schloss|n
schloß|n
schlupfloch|n
schluss-s|n
schlußstein|n
schlußstrich|n
schlüsselloch|n
schmacht|m
schmankerl|n
schmelzbad|n
schmier|f
schmieröl|n
schmierzettel|m
schmollis|n
schmuggelgut|n
schneckengetriebe|n
schneckenhaus|n
schneebrett|m
schneidemesser|n
schnellrestaurant|n
schnitzel|n
schnucki|n
schock|n
schockschwerenot|f
schoggi|f
schoki|f
schoko|f
schokokuchen|m
schokoladebonbon|n
schokoladenbonbon|n
schokoladenkuchen|m
scholion|n
schonfrist|f
schopfpinguin|m
schott|n
schönfinkeln|n
schra|f
schranz|m
schrapnell|n
schreck|m
schrei|m
schreibstil|m
schrifft|f
schrift|f
schriftart|f
schtetl|n
schuhschachtel|f
schuld|f
schulter|f
schuluhr|f
schummelzettel|m
schutzgas|n
schüssel|f
schütteltanz|m
schütz|n
schwa|n
schwadron|f
schwadroneur|m
schwalbenschwanz|m
schwammerl|n
schwanz|m
schwänzeltanz|m
schwarz|n
schwarzarbeiten|n
schwarzfahren|n
schwarzgrau|n
schwarzkittel|m
schwarzmalen|n
schwarztee|m
schwegel|f
schwein|n
schweinderl|n
schweinemast|f
schweineohr|n
schweinsohr|n
schweiß|m
schwermetallion|n
schweröl|n
schwert|n
schwester|f
schwieger|f
schwimmbad|n
schwingtür|f
schwuchtel|f
schwung|m
schwungrad|n
schwur|m
screening|n
sebcha|f
sech|n
sechs|f
sechseck|n
sechsunddreißig|f
sechsundvierzig|f
sechsundzwanzig|f
sechswochenamt|n
sechzig|f
sechzigeck|n
seconda|f
seebad|n
seefledermaus|f
seekuh|f
seenot|f
seeohr|n
seeskorpion|m
segel|n
segelohr|n
seidel|n
seidenschwanz|m
seilspringen|n
seiltanz|m
seismometer|n
seitensprung|m
seitentür|f
sek|n
sekret|n
sekretariat|n
sektbar|f
sekunda|f
sekundenbruchteil|m
sekundenkleber|m
selan|n
selbst|n
selbstlob|n
selenat|n
selenid|n
selenit|n
selenol|n
selenon|n
semester|n
semesterende|n
seminar|n
semmel|f
senfgas|n
senföl|n
senkblei|n
separee|n
séparée|n
sepia|f
seppuku|n
serail|m
serpentin|m
service|m
set-top-box|f
seufzen|n
sexta|f
shakehands|n
shampoo|n
shanty|n
shiitake|m
shirt|n
shisha|f
shooting|n
shortcake|m
shortlist|f
shorts|f
show|f
sichel|f
sicht|f
sideboard|n
sieb|n
sieben|f
siebeneck|n
siebenganggetriebe|n
siebenunddreißig|f
siebenundvierzig|f
siebenundzwanzig|f
siebzig|f
siebzigeck|n
siechenhaus|n
siedeln|n
sieden|n
siedlungshaus|n
siegel|n
siemens|n
sigel|n
signal|n
signet|n
silan|n
silberanteil|m
silbererz|n
silberion|n
silberlot|n
silbermesser|n
silicat|n
silicid|n
silikat|n
silikon|n
simsalabim|n
singleton|n
singulett|n
sinteza|f
sintiza|f
sitar|f
sitcom|f
sittengemälde|n
sitzredakteur|m
skala|f
skalpell|n
skandalon|n
skate|m
skateboard|n
skelett|n
skifahren|n
skioptikon|n
sklera|f
skorpion|m
skript|n
skua|f
slum|m
smartcard|f
smartphone|n
smartwatch|f
smollis|n
smombie|m
smoothie|m
snaresinselpinguin|m
snooker|n
snowboard|n
soap|f
sodasee|m
sofa|n
sofi|f
softeis|n
softie|m
soja|f
sol|n
soldateska|f
solei|n
solfeggio|n
solidaritätssteuer|f
soliton|n
soljanka|f
soll|n
solo|n
sommeraster|f
sommerende|n
sommerhaus|n
sommerloch|n
sonar|n
sonderreich|n
sonett|n
sonn|f
sonnenbad|n
sonnenblumenöl|n
sonnenfinsternis|f
sonnenrad|n
sonnenuhr|f
sorbet|n
soufflé|n
soufflee|n
souffleur|m
souper|n
souterrain|n
souvenir|n
sozialamt|n
spaceshuttle|n
spachtel|m
spagetti|f
spaghetti|f
spalier|n
spaltprodukt|m
spam|f
sparring|n
spatzeck|n
spatzi|n
spätzle|n
species|f
speckgürtel|m
spediteur|m
speicherfrist|f
speik|m
speis|f
speiseeis|n
speiseöl|n
spektakel|n
spektrometer|n
spektroskop|n
spekulationsfrist|f
sperrad|n
sperrangel|f
sperrfrist|f
sperrrad|n
spessartin|m
spezies|f
sphinx|f
spickzettel|m
spider-app|f
spiegelei|n
spiel|n
spielart|f
spielende|n
spielhaus|n
spielo|f
spielothek|f
spieluhr|f
spiessgeselle|m
spießrutenlaufen|n
spike|m
spill|n
spindel|f
spindeluhr|f
spinett|n
spinnerdelfin|m
spinngewebe|n
spinnrad|n
spinnweben|n
spion|m
spital|n
spitex|f
spitzentanz|m
spitzkrokodil|m
spitzmaus|f
splitting|n
sportart|f
sportel|f
sportteil|m
sportuhr|f
sprachenlernen|n
sprachkenntnis|f
sprachkorpus|n
sprachstil|m
sprachteil|m
sprachtheil|m
sprengstoffgürtel|m
sprenkelbeutelmaus|f
springinsfeld|m
springmesser|n
springschwanz|m
sprinten|n
spritzkuchen|m
sprudelbad|n
sprung|m
sps|f
spukhaus|n
spulenfiepen|n
spüli|n
staatengebilde|n
staatsamt|n
stabhochsprung|m
stabi|f
stachelrochen|m
stack|n
stadion|n
stadt|f
stadthaus|n
städtl|n
stadtteil|m
stadttor|n
staffel|f
staffelschwanz|m
stag|n
stahlbad|n
stahlfaß|n
staket|n
stalag|n
stalingrad|n
standardtanz|m
ständehaus|n
standesamt|n
standuhr|f
stangenei|n
stanitzel|n
stannan|n
stannat|n
stannit|n
startelf|f
stasi|f
stativ|n
statut|n
staubmantel|m
stausee|m
steak|n
steakmesser|n
stearat|n
stearin|n
stechbeitel|m
stechuhr|f
steckerl|n
steckerleis|n
stehaufmanderl|n
stehklo|n
steilheck|n
steingebäude|n
steingut|n
steinhaus|n
steinlaus|f
stelldichein|n
stellmesser|n
stempeluhr|f
stenz|m
steppke|m
stepptanz|m
stereo|n
stereotyp|n
sternanis|m
sternenglanz|m
steroid|n
stethoskop|n
stetl|n
steuer|n
steuerrad|n
steuerruder|n
stewardess|f
stg|n
stiegenhaus|n
stielmus|n
stift|n
stil|m
stilett|n
stimmungsbarometer|n
stimmzettel|m
stimulans|n
stirn|f
stockerl|n
stoffmengenanteil|m
stola|f
stoppel|f
stoppie|m
stoppuhr|f
store|m
stornierungsfrist|f
storno|n
story|f
stotze|m
stracciatella|f
straftat|f
strafzettel|m
strahlenkranz|m
stramin|n
strandbad|n
strandgut|n
strappado|n
strategem|n
streaming|n
streetfood|n
streichholzschachtel|f
streik|m
streitaxt|f
streuselkuchen|m
streuungsmaß|n
strickleiter|f
strike|m
stroboskop|n
stroh|n
stromuhr|f
strontiumferrit|n
struggle|m
struma|f
studio|n
stufenheck|n
stuk|f
stund|f
stutze|m
stutzuhr|f
stück|n
stützrad|n
suada|f
subbotnik|m
subjekt|n
substantiv|n
substrat|n
sucht|f
sudelbuch|m
sudoku|n
suffix|n
suffixoid|n
suitier|m
sujet|n
sulfat|n
sulfid|n
sulfit|n
sulfon|n
sulfonat|n
sulfoxylat|n
sultanat|n
sulz|f
sumo|n
sumpf-kratzdistel|f
sumpfkrokodil|m
sup|n
superego|n
superkleber|m
supernova|f
superstrat|n
surimi|n
sushi|n
sutra|n
süffeln|n
sündenbabel|n
svg|n
swastika|f
symbol|n
symposion|n
symptom|n
synchro|f
synchronfirma|f
syndikat|n
syndrom|n
synonym|n
synsemantikon|n
syntax|f
synthesegas|n
synthie|m
system|n
szenar|n
szenario|n
t-hemd|n
t-shirt|n
t*tt*|f
tabaksteuer|f
tablet|n
tablett|n
tabloid|n
tabu|n
tabuisieren|n
tachymeter|n
tachyon|n
tackern|n
tadeln|n
tafel|f
tafeln|n
tagen|n
tagesende|n
taggen|n
taiga|f
takeln|n
takten|n
taktieren|n
tal|n
talent|n
tambour|m
tamburin|n
tamtam|n
tändeln|n
tandem|n
tangieren|n
tanken|n
tankuhr|f
tannin|n
tantalerz|n
tanz|m
tanzbar|f
tänzeln|n
tapet|n
tapezieren|n
tappen|n
tapsen|n
tara|f
tarantel|f
tarnen|n
tartrat|n
taschenmesser|n
taschenuhr|f
tat|f
tätigen|n
tätowieren|n
tätscheln|n
tattern|n
tatütata|n
taubenhaus|n
tauen|n
taufen|n
taugen|n
taumeln|n
tauschwert|m
tausend|n
tausendschön|n
taxieren|n
taxin|f
taxon|n
tbm|n
team|n
teamwork|n
technetat|n
tee|m
tee-ei|n
teebeutel|m
teeei|n
teehaus|n
teenie|m
teigmesser|n
teilhaben|n
teilnehmen|n
tele|n
telefax|n
telefon|n
telefonat|n
telefonieren|n
telemeter|n
telephon|n
telephonieren|n
teleskop|n
telex|n
telko|f
tellurid|n
tempeh|n
temperieren|n
tempo|n
tempus|n
tendieren|n
tenness|n
tensid|n
tenuis|f
teppichklopfer|m
teppichmesser|n
termin|m
terpen|n
terpineol|n
terrain|n
terrorisieren|n
tertia|f
terz|f
tesa|n
tesla|n
testen|n
testieren|n
tetragon|n
tetramer|n
teufelsrochen|m
texten|n
thal|n
that|f
theater|n
theatergebäude|n
thee|m
theil|m
theilhaben|n
theilnehmen|n
thematisieren|n
theorem|n
theoretisieren|n
therapieren|n
thermit|n
thermoplast|m
theta|n
thier|n
thing|n
thiol|n
thioredoxin|n
thor|n
thronen|n
thuja|f
thum|m
thür|f
tiara|f
tibia|f
tic-tac-toe|n
ticken|n
ticket|n
tief|n
tiefbauingenieur|m
tiefkühlen|n
tiefstapeln|n
tier|n
tierart|f
tierreich|n
tigern|n
tikitaka|n
tilgen|n
timbre|n
timen|n
timing|n
tindern|n
tintenfaß|n
tipi|n
tiramisu|n
tischuhr|f
titanat|n
titel|m
titeln|n
titrieren|n
tixo|n
tjost|f
toasten|n
tobel|n
toben|n
tochter|f
tocktail|m
todeslos|n
todestal|n
toga|f
tohuwabohu|n
tollhaus|n
tomatenmark|n
tombola|f
tonangel|f
tonart|f
tonicwater|n
tonie|n
toniebox|f
toningenieur|m
tonleiter|f
tonnengewölbe|n
tontscha|f
tool|n
top|n
toponym|n
topping|n
tor|n
torba|f
torfmoor|n
tortilla|f
totem|n
totenreich|n
toupet|n
toxin|n
töggelen|n
törin|f
trachom|n
tracht|f
tragen|n
trägergas|n
tragerl|n
traggas|n
trail|m
trainee|m
training|n
tram|f
trampolin|n
tränengas|n
transferrin|n
transparent|n
transpi|n
transplantat|n
transsumpt|n
transumpt|n
trapez|n
trapezoid|n
trassee|n
trauermantel|m
travertin|m
treff|n
treffen|n
treibgas|n
treibgut|n
treibhaus|n
treibhausgas|n
treppenhaus|n
trias|f
tribometer|n
tribunal|n
tribus|f
triell|n
trift|f
trikot|n
trimester|n
trinken|n
trinkgelage|n
trio|n
triol|n
triolett|n
tripel|n
triphylin|m
triple|n
triplett|n
triptychon|n
tritid|n
trittleiter|f
triumvirat|n
trivialisieren|n
trockental|n
troika|f
trommel|f
trommeln|n
trottel|m
trotti|n
trottinett|n
trottoir|n
tröpferlbad|n
trulla|f
trumm|n
trumpfen|n
truppenteil|m
trutschel|f
trübsal|f
tschernobyl|n
tschik|m
tuba|f
tuch|n
tugend|f
tulipan|f
tundra|f
tunika|f
tupel|n
turboprop|n
turmalin|m
turmuhr|f
turnbeutel|m
turnier|n
turse|m
turtel|f
tussi|f
tutorial|n
tutu|n
tuwort|n
tür|f
türangel|f
türkenklo|n
türklopfer|m
türspion|m
typin|f
u-bahn|f
u-boot|n
u-hakerl|n
ud|f
ufer|n
ufo|n
uhr|f
ukelei|m
ulab|n
ulkus|n
ulti|f
ululieren|n
umbra|f
umfeld|n
umkugel|f
umranden|n
umsatzsteuer|f
umschrift|f
umschwung|m
umwelt|f
unboxing|n
undecan|n
unding|n
unentschieden|n
unfriede|m
ungeheuer|n
ungeheur|n
ungemach|n
ungetüm|n
ungeziefer|n
unglaube|m
unglück|n
ungunst|f
uni|f
uni-bib|f
unikat|n
unisono|n
universalgenie|n
unkenntnis|f
unkraut|n
unperson|f
unrecht|n
unruh|f
unschlitt|n
untat|f
unterart|f
unterfangen|n
unterhaus|n
unterkunft|f
unternehmen|n
unterpfand|n
unterreddit|n
untersattel|m
unterscheidungsmerkmal|m
untertitel|m
untertribus|f
untier|n
untugend|f
unvermögen|n
unverständniss|n
unwesen|n
unwetter|n
unwort|n
unwucht|f
unwürdigsein|n
unzahl|f
unzeit|f
update|n
upselling|n
uranerz|n
urbar|n
urbild|n
urethan|n
urgestein|n
urheimat|f
urinal|n
urli|f
urmeer|n
urmutter|f
uroma|f
urschrei|m
urschrift|f
ursprung|m
urstromtal|n
urtier|n
urviech|n
urvieh|n
urzeit|f
uschanka|f
usv|f
uvula|f
uwa|f
uzi|f
übel|n
übeltat|f
über-ich|n
überanstrengen|n
überbleibsel|n
überbringen|n
übereignen|n
überfinanzieren|n
überfrankieren|n
überhören|n
überich|n
überlagern|n
übermorgen|n
übersiedlungsgut|n
überwuchern|n
v-person|f
vagina|f
vakzin|n
vampirfledermaus|f
vanadat|n
vanadiumerz|n
vanadocen|n
varieté|n
varietee|n
vaterunser|n
vau|n
vb|n
veggie|m
vehikel|n
veitstanz|m
veld|n
velo|n
velodrom|n
velours|n
vendetta|f
venn|n
veranda|f
veränderungswille|m
veranstaltungstermin|m
verb|n
verband|m
verbot|n
verbotsirrtum|m
verbrauchssteuer|f
verbrauchsteuer|f
verbrenner-aus|n
verdacht|m
verdammnis|f
verdienst|n
vereinshaus|n
verfahren|n
vergehen|n
vergissmeinnicht|n
vergnügen|n
vergnügungssteuer|f
verhaft|m
verhalten|n
verhältniss|n
verhängniss|n
verhör|n
verjährungsfrist|f
verlan|n
verlangen|n
verlies|n
verlust|m
vermicelle|n
vermögen|n
verrinnen|n
verrücken|n
versammlungsgebäude|n
versehen|n
versetzen|n
versmaß|n
verso|n
verständniss|n
versteck|n
verteufeln|n
verwaltungsgebäude|n
verwaltungsgeschwurbel|n
verwaltungssprech|n
verzeichniss|n
verzinsen|n
verzweiflungstat|f
vesper|f
vestibül|n
veto|n
vettel|f
vga|f
vhs|f
vibe|m
vibrato|n
video|n
viech|n
vieh|n
vieleck|n
vielflach|n
vier|f
vierterl|n
vierunddreißig|f
vierundvierzig|f
vierundzwanzig|f
vierzig|f
vierzigeck|n
vigil|f
villa|f
vinothek|f
vinyl|n
viola|f
viper|f
virago|f
virgel|f
visa|n
visier|n
vitamin|n
vitiligo|f
vivat|n
vize|m
vizegouverneur|m
vizekönigreich|n
vizin|f
vk|f
vl|f
vlies|n
vo|f
vogel-v|n
vogelhaus|n
voicemail|f
vokabel|f
vokabular|n
vokuhila|f
vokü|f
vola|f
volck|n
volk|n
volkstanz|m
vollgas|n
vollstreckungstitel|m
volltrottel|m
vollzeitäquivalent|n
volt|n
volumen|n
volumenprozent|n
volunteering|n
voraussenden|n
vorderrad|n
vordertür|f
voreinstellen|n
vorgebirge|n
vorgewende|n
vorhaben|n
vorhut|f
vorkommen|n
vorschlaghammer|m
vorsprung|m
vorstellungsende|n
vorteil|m
vortheil|m
vorwand|m
voyeur|m
völva|f
vu|n
vulva|f
vuvuzela|f
wachstumsvorsprung|m
wacht|f
wachtel|f
wachtelei|n
wadi|n
waffel|f
waffenhaus|n
wahl|f
wahlzettel|m
waisenhaus|n
wallbox|f
walnuß|f
walstatt|f
wams|n
wand|f
wandergewerbe|n
wandgemälde|n
wanduhr|f
wangenknochen|m
want|f
wappen|n
waqf|f
warenhaus|n
warft|f
warnstreik|m
wartburg|m
wartefrist|f
wartehaus|n
waschnuß|f
waserl|n
wasser|n
wasserbad|n
wasserfaß|n
wasserloch|n
wasserpfeifenbar|f
wasserrad|n
wasserskorpion|m
wasserstoffion|n
waterloo|n
watt|n
wbf|f
wc|n
wearable|n
webinar|n
weckamin|n
weckerl|n
weekend|n
wegekreuz|m
wegge|m
wegkreuz|m
weh|n
wehr|f
wehrersatzamt|n
weib|n
weichei|n
weichlot|n
weichsel|f
weihnachten|n
weihnachtskranz|m
weihrauchfaß|n
weinfaß|n
weingut|n
weinhaus|n
weinrot|n
weiß|n
weißflügelpinguin|m
weißgrau|n
weitsprung|m
weitwinkel|n
weizen|n
weizenkeimöl|n
welt|f
weltreich|n
weltwissen|n
weltzeituhr|f
wembley-tor|n
wendehammer|m
wendel|f
wendemantel|m
wenn|n
werck|n
werft|f
werg|n
werk|n
werkstatt|f
wermutöl|n
werst|f
wertsteuer|f
wesen|n
wettbewerbsvorteil|m
wetter|n
wg|f
whatsapp|f
whist|n
whiteboard|n
wholecar|n
wicht|n
wichtel|m
widerwille|m
wiederkunft|f
wiedersehen|n
wiel|f
wiesel|n
wiesenrain|m
wiesn|f
wieß|n
wii|f
wiki|n
wild|n
wildnis|f
wille|m
willkommen|n
wimmerl|n
wimper|f
windbeutel|m
windel|f
windrad|n
windsurfen|n
windsurfing|n
winterende|n
wintermantel|m
wirrnis|f
wirrsal|n
wirtschaftsabschwung|m
wirtschaftsaufschwung|m
wirtshaus|n
wissenschaftsmagazin|n
wittib|f
wka|f
wlan|n
wm|f
wobla|f
wochenende|n
wochenendhaus|n
wohl|n
wohltat|f
wohnhaus|n
wohnstallhaus|n
wohnungstür|f
wojenkomat|n
wolfsangel|f
wolfsrachen|m
wolfsschwanz|m
wollmantel|m
wollmaus|f
wort|n
wortart|f
wotin|f
wrack|n
wucht|f
wudu|n
wulfenit|n
wunder|n
wunschzettel|m
wurfmesser|n
wurmloch|n
wurst|f
wurstebrei|m
wurstmesser|n
wurt|f
wurz|f
wurzel|f
wurzelgewebe|n
wutz|f
wühlmaus|f
würgereflex|m
würgreflex|m
wüstenrennmaus|f
wüstenspringmaus|f
wv|f
xanthogenat|n
xi|n
xxo|n
xylem|n
xylofon|n
xylophon|n
yacht|f
yang|n
ylid|n
yperit|n
ypsilon|n
yttriumerz|n
yucca|f
yuppie|m
zaddik|m
zahl|f
zahlungsart|f
zahlungsfrist|f
zahnrad|n
zapfe|m
zarenreich|n
zarentum|m
zarin|f
zebra|n
zeder|f
zehn|f
zehneck|n
zehnerl|n
zeichnungsfrist|f
zeiland|m
zeilensprung|m
zeit|f
zeitalter|n
zeitfahren|n
zeitschaltuhr|f
zeitungsredakteur|m
zeitungsstil|m
zelluloid|n
zelt|n
zement|m
zenotaph|n
zerlassen|n
zertifikat|n
zeta|n
zett|n
zettel|m
zeug|n
zeughaus|n
zeugniss|n
zeugs|n
ziel|n
ziffer|f
zigarettenschachtel|f
zigeunern|n
ziggurat|f
zikkurat|f
zikkurrat|f
zimbal|n
zimbel|f
zimmer|n
zimmermannshammer|m
zimmertür|f
zink|n
zink-pyrithion|n
zinkat|n
zinkerz|n
zinkion|n
zinkspat|n
zinn|n
zinnerz|n
zinshaus|n
ziqqurat|f
ziqqurrat|f
zirbel|f
zirbelnuß|f
zirkonat|n
zirkumfix|n
zirkumflex|m
zitat|n
zither|f
zitronat|n
zk|n
zollamt|n
zollhaus|n
zombie|m
zottel|f
zölestin|m
zubilligen|n
zubrot|n
zucchetti|f
zucht|f
zuchthaus|n
zuckerei|n
zuckerl|n
zuckersteuer|f
zuerkennen|n
zufahrt|f
zufuhr|f
zuhause|n
zukunft|f
zuname|m
zunft|f
zur-verfügung-stellen|n
zurechtlegen|n
zurückgeben|n
zurücktreten|n
zurverfügungstellen|n
zusammenbleiben|n
zusammenkunft|f
zuspätkommen|n
zuspiel|n
zustandekommen|n
zutat|f
zuthat|f
zuwachsen|n
zügelpinguin|m
zürbel|f
zwangsernähren|n
zwangsversteigern|n
zwanzig|f
zwanzigeck|n
zweifamilienhaus|n
zweifamilienwohnhaus|n
zweitor|n
zweiunddreißig|f
zweiundfünfzig|f
zweiundvierzig|f
zweiundzwanzig|f
zwerchhaus|n
zwergenwerfen|n
zwergfledermaus|f
zwergpinguin|m
zwetschgenkuchen|m
zwiebel|f
zwiebelkuchen|m
zwiefalt|f
zwischenhoch|n
zwischenlagern|n
zwitterion|n
zwölf|f
zwölfeck|n
zyanid|n
zyklometer|n
zytochrom|n
zytokin|n
zytostom|n
zytotoxin|n
zytozym|n
`;

const PLURAL_DATA = `*rschl*ch|er
1-euro-job|s
aalmutter|n
aalschwanz|ue
aam|s
abandon|s
abaton|-2a
abbau|e
abbé|s
abbild|er
abblendlicht|er
abbrand|ue
abdach|uer
abdampf|ue
abenomics|
abessinier|
abfall|ue
abflug|ue
abfluss|ue
abfluß|=Abflüsse
abgang|ue
abgott|uer
abgrund|ue
abguss|ue
abguß|=Abgüsse
abh.|
abhang|ue
abitur|e
ablass|ue
ablaß|=Ablässe
ablauf|ue
abluft|ue
abmarsch|ue
aborigine|s
abortus|
absatz|ue
abschiedskuß|=Abschiedsküsse
abschlag|ue
abschluss|ue
abschluß|=Abschlüsse
abschub|ue
abschuss|ue
abschwung|ue
absolutbetrag|e
abstand|ue
abstoß|ue
abstract|s
abstraktum|-2a
absturz|ue
abt|ue
abwasch|ue
abwasser|u
abwurf|ue
abzug|ue
accessoire|s
achaier|
acker|u
action|s
actioncomic|s
acyloin|e
adabei|s
adamin|e
ade|s
adeliepinguin|e
adenin|e
adlatus|-2en
adobe|s
adt|s
advent|e
adventkranz|ue
adventskranz|ue
aegyptier|
aera|en
aerobier|
aerogel|e
aeroplan|e
afa|
äffin|nen
affront|s
afterhour|s
aftershave|s
agenda|-1en
agioteur|e
ahnenpaß|=Ahnenpässe
ahnin|nen
aimbot|s
airbag|s
airline|s
airport|s
ais|
aiw|u
ajatollah|s
akkordeon|s
akteur|e
aktiensplit|s
akupunkteur|e
akzent|e
alabandin|e
alanin|e
alant|e
albanier|
albatros|se
albumin|e
ale|s
alexin|e
algebra|-1en
algerier|
algorithmus|-2en
alija|=Alijot
aliya|=Aliyot
alkali|en
alken|e
allargentum|e
allel|e
allergen|e
allerlei|s
allotria|
alman|s
almandin|e
alpenpaß|=Alpenpässe
alpental|uer
altar|ue
altbau|=Altbauten
alternativmedizin|en
altersaufbau|=Altersaufbauten
alterthum|uer
altertum|uer
altmaterial|=Altmaterialien
altneubau|=Altneubauten
aluminiumleichtbau|en
amaretto|-1i
amaryllis|-2en
amateur|e
ambrosia|-1en
ametrin|e
ampere|
amphetamin|e
amphiprostylos|-2en
amphoter|e
amt|uer
amüsement|s
amygdala|e
amylen|e
anabolikum|-2a
analemma|=Analemmata
analgetikum|-2a
analogon|-2a
analplug|s
anaphrodisiakum|-2a
anästhetikum|-2a
anathema|=Anathemata
anbau|=Anbauten
anchorman|-2en
anchovis|
andenkondor|e
androgen|e
aneurysma|-1en
anfall|ue
anfang|ue
anflug|ue
angelschnur|ue
angesicht|er
angina|-1en
angiotensin|e
anglerhut|ue
angst|ue
ångström|
anhang|ue
anilingus|-2i
animateur|e
anion|e
anisette|s
ankauf|ue
anklang|ue
ankunft|ue
anlagehorizont|=Anlagehorizont-e
anlagenbau|=Anlagenbauten
anlageparameter|=Anlageparameter-e
anlagezeitraum|=Anlagezeitraum-e
anlass|ue
anlaß|=Anlässe
anlauf|ue
anlegergeld|e
anmarsch|ue
anmeldebogen|u
anorak|s
ansatz|ue
anschlag|ue
anschluss|ue
anschluß|=Anschlüsse
anschovis|
anstand|ue
anstoß|ue
antaphrodisiakum|-2a
antazidum|-2a
antibiotikum|-2a
antidepressivum|-2a
antiemetikum|-2a
antigen|e
antihistaminikum|-2a
antihypertensivum|-2a
antikoagulans|=Antikoagulantien
antimakassar|s
antimonfluorid|s
antimonglanz|e
antimykotikum|-2a
antioxidans|=Antioxidantien
antiphlogistikum|-2a
antiphrasis|-2en
antipyretikum|-2a
antiquark|s
antispasmodikum|-2a
antitranspirant|e
antrag|ue
antriebsrad|uer
anus|-2i
anwalt|ue
anxiolytikum|-2a
anzug|ue
aorist|e
aorta|-1en
apartment|s
apastron|-2a
apex|=Apizes
apfel|u
apfelkorn|s
aphäresis|-2en
aphel|e
aphrodisiakum|-2a
apokryph|en
app|s
appartement|s
appel|u
appelkorn|s
appellativum|-2a
appendix|=Appendizes
appendizitis|=Appendizitiden
applaudeur|e
applaus|e
applet|s
apsis|=Apsiden
aquamarin|e
aquavit|s
aquifer|e
äquivalenzprinzip|=Äquivalenzprinzipien
ar*****ch|er
ar***l*ch|er
ära|-1en
arbeitsamt|uer
arbeitseinsatzingenieur|e
arbeitsmaterial|=Arbeitsmaterialien
arbeitspaß|=Arbeitspässe
arbeitsplatzabbau|=Wirtschaftszyklen
arbeitsschluß|=Arbeitsschlüsse
arch.|
archetyp|en
arena|-1en
argentinier|
arginin|e
ariadnefaden|u
arier|
ariseur|e
arista|e
arkadenhof|ue
armenier|
aroma|-1en
aromat|en
arrangement|s
arrangeur|e
arrondissement|s
arsch|ue
arschin|en
arsenobetain|e
arsenocholin|e
arsphenamin|e
artepithet|a
arthritis|=Arthritiden
artikelwort|uer
artzt|ue
arylamin|e
arzt|ue
arzttermin|e
as|se
asant|e
ascus|-2i
asp|
aspie|s
ast|ue
asternstrauss|ue
asyndeton|-2a
at|s
atelier|s
atemzug|ue
äthiopier|
athletenherz|en
atlas|=Atlanten
atlatl|
atomradius|-2en
atomreaktor|e
atrazin|e
attaché|s
au|en
au-pair|s
audiobook|s
aufbau|=Aufbauten
aufblendlicht|er
auffgang|=Auffgenge
aufschluß|=Aufschlüsse
aufschrei|e
aufschwung|ue
aufsichtsrat|ue
auftrag|ue
aufzug|ue
aug|en
augenglas|uer
augenlicht|er
augenlid|er
augentyp|en
aura|-1en
ausfallrisiko|e
ausflucht|ue
ausfluß|=Ausflüsse
ausgangsmaterial|=Ausgangsmaterialien
ausgangszustand|=Ausgangzustände
ausguß|=Ausgüsse
aushängeschild|er
auskunft|ue
auslandskaufkraft|en
auslass|ue
ausr.|
ausrufewort|uer
ausschluß|=Ausschlüsse
ausschuß|=Ausschüsse
außenhaut|en
außenkaufkraft|en
außenohr|en
ausstoss|ue
australier|
auszug|ue
autoblock|s
autobus|se
autocar|s
autodafé|s
autohof|ue
autoreparaturwerkstatt|uen
autosemantikon|-2a
autosemantikum|-2a
autowerkstatt|uen
axolotl|
axt|ue
baart|=Bärte
babylonier|
bach|ue
bach-chor|ue
bachchor|ue
bachelorthesis|-2en
backend|s
bad|uer
badetuch|uer
bahnhof|ue
bai|en
bain-marie|=Bains-Marie
bakkalaurea|e
bakkalaureus|-2i
bakkie|s
baldachin|e
ball|ue
bällebad|uer
ballerina|-1en
balley|en
ballsaal|=Ballsäle
bambus|se
bamia|-1en
band|uer
bandwurm|uer
bank|ue
bankerl|
bankier|s
banshee|s
bar|s
barbadier|
barbadierin|=Bardierinnen
barchent|e
bärenmarkt|e
bärin|nen
barockschloß|=Barockschlösser
bart|ue
baryon|en
baschlik|s
baseball|s
basecap|s
basilika|-1en
basis|-2en
basismaterial|=Basismaterialien
bass|ue
baß|=Bässe
bassin|s
baßtuba|-1en
bauch|ue
bauchtanz|ue
bauernhof|ue
bauingenieur|e
baum|ue
baumast|ue
baumaterial|=Baumaterialien
baumnuß|=Baumnüsse
baustahl|ue
bazillus|-2en
beanie|s
beat|s
beatnik|s
bébé|s
becherglas|uer
beer|en
befall|ue
befr.|
begutachtungsausschuß|=Begutachtungsausschüsse
behemot|s
behemoth|s
beigeschmack|ue
beirat|ue
beitrag|ue
beiwort|uer
belag|ue
belagerungszustand|=Belagerungzustände
belgier|
benjamin|e
benz|e
benzin|e
bergahorn|e
berggeist|er
bergsturz|ue
bergtal|uer
bernd|s
berufsabschluß|=Berufsabschlüsse
bes|
besanmast|en
besatz|ue
beschäftigungsrückgang|e
beschichtungsmaterial|=Beschichtungsmaterialien
beschlag|ue
beschluss|ue
beschreibungswort|uer
beschuß|=Beschüsse
besitztum|uer
bestand|ue
bestimmungswort|=Bestimmungwörter
betain|e
betonstahl|ue
betrag|ue
betriebsaufwand|e
betriebsrat|ue
betrug|ue
bett|en
betttuch|uer
bettuch|uer
beutegut|uer
beweisung|ue
beytrag|ue
beywort|uer
bezirksamt|uer
bezirksausschuß|ue
bezug|ue
bezugswort|uer
bib|s
biberschwanz|ue
bidet|s
bierfaß|=Bierfässer
bierglas|uer
biest|er
bild|er
billetdoux|
billeteur|e
bim|s
bindebogen|u
bindewort|uer
bindfaden|u
binnenkaufkraft|en
biomaterial|=Biomaterialien
biorhythmus|=Biohythmen
bip|s
bipyridin|e
birken-ast|ue
birkenast|ue
bis|
bischof|ue
bisthum|uer
bistum|uer
bit|s
bitch|=Bitches
bitcoin|s
bks|
blag|en
blasensprung|ue
blatt|uer
blattschuß|=Blattschüsse
blaufränkisch|en
blaulicht|er
bleifuß|ue
bleigeschoß|=Bleigeschosse
bleiglas|uer
blicksilber|s
blik|e
blitzlicht|er
blockchain|s
bloodhound|s
bluff|s
blumenkohlohr|en
blumenkranz|ue
blumenstrauss|ue
blunt|s
blutbad|uer
blutbank|en
blutdruck|e
bluterguß|=Blutergusse
blutkreislauf|e
blutrot|
blutrunst|ue
blutsturz|ue
blütenstaub|ue
bob|s
bocher|=Bocherim
bock|ue
boden|u
bodenschatz|ue
bodybag|s
bodyguard|s
boeing|s
bofist|e
bogenschuß|=Bogenschüsse
bohemien|s
bokeh|s
bollenhut|ue
bolzenschuß|=Bolzenschüsse
bombardement|s
bon|s
bonanzarad|uer
bong|s
bonmot|s
bonvivant|s
boofke|s
bookmark|s
boom|s
boomtown|s
boonekamp|s
borg|ue
borosilikatglas|uer
borstenschwanz|ue
boskoop|
boskop|
bosner|
bosnier|
boson|en
bot|s
bouclé|s
boudoir|s
bouillon|s
boulevard|s
bouquet|s
bourrée|s
bovist|e
bowdenzug|ue
bowl|s
boxenstopp|s
boyfriend|s
boygroup|s
börek|s
börsenaufschwung|e
börsencrash|s
börsenmantel|=Mäntel
börsenschluss|e
börsenumsatz|e
böse|
bps|
brain|s
brainstorming|s
bramarbas|se
brand|ue
brandmail|s
brandschatz|ue
brandteigkrapferl|
bratan|s
brauch|ue
brauchtum|uer
braunwurz|e
brausebad|uer
braut|ue
brautschatz|ue
brautstrauss|ue
bre|s
break|s
brechnuß|=Brechnüsse
brei|e
breitbandantibiotikum|-2a
bremszug|ue
brennmaterial|=Brennmaterialien
brennschluß|=Brennschlüsse
brett|er
brezen|
brezn|
brillenglas|uer
brillenpinguin|e
brioche|s
britannier|
broccoli|
brokkoli|
bromalken|e
bronchitis|=Bronchitiden
brownie|s
brötli|
bruch|ue
bruder|u
bruderhof|ue
brummbär|en
bruneier|
brunft|ue
brunftschrei|e
brunst|ue
brust|ue
bruttogehalt|er
bruttolohn|e
bruttosozialprodukt|
bruttoumsatz|e
bubenspitzle|
bubespitzle|
buch|uer
buchdruck|e
buchenast|ue
buchstabenwort|uer
budget|s
buffet|s
buklee|s
bulin|
bullenmarkt|e
bulletin|s
bulletpoint|s
bummelzug|ue
bund|ue
bundesamt|uer
bundesrat|ue
bundeswahlausschuß|=Bundeswahlausschüsse
bungalow|s
burgstall|e
burgunderrot|
burin|nen
burn-out|s
burnout|s
burnus|se
bus|se
busch|ue
butch|=Butches
buten|e
butterfaß|=Butterfässer
button|s
butylen|e
buzzword|s
bübin|nen
bücherwurm|uer
büchsenfagott|e
büfett|s
bügelverschluß|=Bügelverschlüsse
bürgeramt|uer
bürgerhaus|er
büßergewand|en
bw|
bypass|ue
caban|s
cabaret|s
cabochon|s
cabriolet|s
cache|s
cachet|s
cadaverin|e
cafe|s
café|s
caisson|s
caldera|-1en
calendula|e
call|s
cam-rip|s
camion|s
camp|s
canadier|
canapé|s
candystorm|s
canticum|-2a
canyon|s
cape|s
car|s
caravan|s
carben|e
carboxy|e
cardigan|s
carlshafen|
carnitin|en
carotin|e
carrot-cake|s
cashewnuß|=Cashewnüsse
cashflow|s
casting|s
casus|
catering|s
celsius|
cermet|s
ces|
cfk|en
chalkogen|e
chalkogenidglas|uer
chalkosin|e
challenge|s
chamäleon|s
champignon|s
champion|s
chanson|s
chansonier|s
chansonière|s
chansonnier|s
chansonnière|s
character|s
charakteristikum|-2a
charakterzug|ue
charmeur|e
chassid|=Chassidim
chassis|
chat|s
chatbot|s
chatroom|s
chauffeur|e
chawer|n
cheat|s
check|s
checkpoint|s
chef|s
chefredakteur|e
cheminée|s
chemokin|e
chemotaxis|-2en
chemotherapeutikum|-2a
chiasmus|-2en
chick|s
chicken-nugget|s
chickennugget|s
chignon|s
chip|s
chirograf|en
chirograph|en
chloralken|e
chloraromat|e
chocolatier|s
cholin|e
chor|ue
choral|ue
chorherr|en
christenthum|uer
christentum|uer
chromatid|en
chromophor|e
chromosom|en
chromstahl|ue
chunk|s
chur-fürstenthum|uer
churfürstenthum|uer
circus|se
cis|
citrin|e
clan|s
claqueur|e
clavicula|e
clearing|s
cleaver|s
cliché|s
clickbaiting|s
client|s
cloud|s
clown|s
club|s
clubbing|s
clypeus|
coaching|s
cockpit|s
cocktail|s
cocktailbar|s
code|s
codeblock|ue
codex|=Codices
coelestin|e
cognac|s
coiffeur|e
college|s
collier|s
come-back|s
comeback|s
comedian|s
coming-out|s
comingout|s
commenthur|e
commenthurey|en
commit|s
communiqué|s
compliance|s
comthur|e
comthurey|en
conférencier|s
containerterminal|s
content|s
conterfät|s
conterfeit|s
conterfet|s
conterfeth|s
continent|e
conurbation|s
cop|s
copyright|s
cornet|s
corona|-1en
coronavirus|-2en
corps|
corpus|=Corpora
cottage|s
couleur|s
count-down|s
countdown|s
coup|s
coupé|s
coupon|s
couseng|s
cousin|s
couvert|s
cölestin|e
crack|s
creator|
crème|s
croupier|s
crwth|
cue|s
cumulonimbus|se
cumulus|-2i
cunnilingus|-2i
cup|s
cupcake|s
curcuma|=Curkumen
cursor|
cut|s
cyborg|s
cyclodextrin|e
cystin|e
cytoblast|en
cytokin|e
cytostatikum|-2a
csd|s
d-mark|
d-zug|ue
dach|uer
dachgeschoß|=Dachgeschosse
dad|s
daktylus|-2en
damm|ue
dämon|en
dampf|ue
dampflok|s
dänin|nen
darm|ue
darmverschluß|=Darmverschlüsse
dars|=Durus
dart|s
dashboard|s
dataset|s
date|s
datenbank|en
datenleck|s
datentyp|en
dauphin|s
daus|uer
dba|
deadline|s
deadname|s
deal|s
debüt|s
deck|s
deckenlicht|er
decorator|s
deern|s
defensio|=Defensiones
defibrillator|e
deflationsdruck|e
deformationsgeschoß|=Deformationsgeschosse
dehnungs-h|
deka|
dekolleté|s
dekolletee|s
dekorateur|e
delfin|e
delphin|e
departementsrat|ue
department|s
depositenbank|en
depot|s
derivatemarkt|e
dermatitis|=Dermatitiden
des|
deserteur|e
design|s
desktop|s
dessert|s
dessous|
detail|s
deuteron|en
devisenabfluß|=Devisenabflüsse
devisenmarkt|e
devisenzufluß|=Devisenzuflüsse
dextrin|e
dezi|
diakritikon|-2a
diakritikum|-2a
dialektkontinuum|-2a
diaphragma|-1en
diatretglas|uer
dibbuk|s
dibenzodioxin|e
dichtungsmaterial|=Dichtungsmaterialien
dickpic|s
dickschnabelpinguin|e
diebstahl|ue
dielektrikum|-2a
dienstlaptop|s
dienstleistungsgewerbe|n
dienstleistungssektor|e
digestif|s
digitus|-2i
diktum|-2a
dillo|e
dimer|e
diner|s
dingwort|uer
dinkeldörte|s
dinucleotid|en
diorama|-1en
diphenylether|e
diplomingenieur|e
diproton|en
dipsomane|
dirham|s
dirhem|s
dirndl|n
dis|
discount|s
diskant|e
diskordier|
diskussionsfaden|u
diss.|
distichon|-2en
disziplin|en
diterpen|e
diuretikum|-2a
diva|-1en
dividendenanspruch|e
dj|s
dock|s
doktrin|en
dolchstoss|ue
domain|s
domherr|en
dompteur|e
donut|s
dope|s
doppelpack|s
doppelschwanz|ue
dorf|uer
dorn|en
dornhai|e
dosenpfand|uer
dosenverschluß|=Dosenverschlüsse
dosis|-2en
dossier|s
doublé|s
doughnut|s
download|s
doyen|s
dozierton|ue
dötzchen|=Dötchen
dragee|s
dragée|s
draht|ue
drama|-1en
drang|ue
drangsal|e
drecksau|ue
dreier|
dreifuß|ue
dreipaß|=Dreipässe
dreirad|uer
dreisprung|ue
dresseur|e
dressing|s
drink|s
drive|s
druck|ue
ds-gvo|s
dsgvo|s
dublee|s
duckface|s
duft|ue
dunkelbraun|
dunkelrot|
dunst|ue
durchgangszug|ue
durchzug|ue
durian|s
dürüm|
dvd|s
e-bike|s
e-book|s
easteregg|s
eb|
effektenmarkt|e
efk|s
ehrenamt|uer
ei|er
eibenast|ue
eichen-ast|ue
eichenast|ue
eichenhain|e
eierklar|
eiertanz|ue
eigenkapital|=Eigenkapitalien
eigenschaftswort|uer
eigent.-whg.|=Eigent.-Whgn.
eigt.-whg.|=Eigt.-Whgn.
eiklar|
eilzug|ue
ein-euro-job|s
einband|ue
eineurojob|s
einfluß|=Einflüsse
eingeweide|
einguß|=Eingüsse
einkommenskluft|en
einkunft|ue
einlass|ue
einlaß|=Einlässe
einmachglas|uer
einrad|uer
einschluß|=Einschlüsse
einsendeschluß|=Einsendeschlüsse
einstellungsstopp|e
einstimmigkeitsprinzip|=Einstimmigkeitsprinzipien
einsturz|ue
eintrag|ue
einweckglas|uer
einwegglas|uer
einwegpfand|uer
einzeldosis|en
einzug|ue
eisenguß|=Eisengüsse
eisenhut|ue
eiskreme|s
eisprung|ue
eistee|s
eiterfluß|=Eiterflüsse
ejalet|s
ekhk|
eklat|s
ekphrasis|-2en
ekranoplan|e
el|
elastizitätsmodul|n
elastomer|e
elegant|s
elektroanschluß|=Elektroanschlüsse
elektroingenieur|e
elektron|en
elektronendonor|
elektronenvolt|
elfin|nen
elytron|-2en
em|s
email|s
emissionsmarkt|e
empfangsherr|en
endwort|uer
energieaufnahme|=Energieaufnahmem
energiefluß|=Energieflüsse
engagement|s
engelhai|e
engpaß|=Engpässe
ensemble|s
entbindungstermin|e
enthusiasmus|-2en
entrecote|s
entree|s
entrée|s
entschluß|=Entschlüsse
entwicklungsvorsprung|ue
entzug|ue
enzyklika|-1en
enzyminduktor|e
epiglottis|=Epiglottiden
epithel|=Epithelien
epitheton|-2a
epos|-2en
eprouvette|s
epsilon|s
equipment|s
erbin|nen
erbwort|uer
erdnuß|=Erdnüsse
eredivisie|s
erfindergeist|er
erfolgsfan|s
ergebnisabführungsvertrag|e
erguss|ue
erguß|=Ergüsse
erhaltungszustand|=Erhaltungzustände
erkenntniß|=Erkenntnisse
erlag|ue
ern|
eroberungszug|ue
eröffnungszug|ue
erratum|-2a
ersatzrad|uer
erstdruck|e
ertrag|ue
ertz-bischoff|ue
ertz-bisthum|uer
ertzbischoff|ue
erzbisthum|uer
erzbistum|uer
erzherzogshut|ue
erzherzogthum|uer
erzherzogtum|uer
es|
eselsohr|en
eselspinguin|e
estin|nen
eszett|
etalon|s
étang|s
etat|s
etwas|
eudämon|en
eutektikum|-2a
exbibyte|s
exception|s
exfrau|en
existenzminimum|-2a
exit|s
exmann|uer
exodus|se
exporteur|e
exportgut|uer
exposé|s
exposee|s
extension|s
extranet|s
extremum|-2a
f*tz*|n
fach|uer
facharztzentrum|=Facharztentren
fächerschwanz|ue
fachkräftemangel|
fackelzug|ue
fadenwurm|uer
fahrrad|uer
fahrradschloß|=Fahrradschlösser
fake|s
faktura|-1en
falchion|s
fall|ue
fallout|s
fallstrick|e
fan|s
fan-fiction|s
fanblock|ue
fancomic|s
fanfiction|s
fang|ue
fant|e
farad|
farbton|ue
fass|uer
faß|=Fässer
fasson|s
fatum|-2a
fauna|-1en
faust|ue
faustpfand|uer
fauxpas|
feature|s
feedback|s
feeling|s
fehlschluß|=Fehlschlüsse
fehlschuß|=Fehlschüsse
feier|n
feinstaub|ue
feld|er
feldrain|e
feldzug|ue
felgaufschwung|ue
fellatio|=Fellationes
felsblock|ue
felsenpinguin|e
felsvorsprung|ue
femininum|-2a
fensterglas|uer
fenstersturz|ue
fernglas|uer
fernsehredakteur|e
fernzug|ue
ferredoxin|e
ferritin|e
ferrocen|e
ferrochrom|
feschak|s
festgehalt|er
festival|s
feston|s
festzug|ue
fettarsch|ue
fetus|-2en
feuchtigkeitscreme|s
feuerstahl|ue
feuilleton|s
ffg|s
fiberglasgehäuse|n
fiberglasschaft|ue
fichtenast|ue
fick|s
filet|s
filia|e
filmmaterial|=Filmmaterialien
filmregisseur|e
filmstar|s
filzhut|ue
final|s
financier|s
finanzamt|uer
finanzier|s
finanzierungsvorgang|=Finanzierungsvorgang-e
finanzierungszyklus|se
fingerbreit|
fingerhut|ue
firewall|s
firlefanz|e
firma|-1en
fis|
fischerhut|ue
fist|e
fistbump|s
fitis|se
fixie|s
fixierbad|uer
flachglas|uer
flak|s
flaneur|e
flaschengeist|er
flaschenverschluß|=Flaschenverschlüsse
flaschenzug|ue
flash-back|s
flashback|s
flashmob|s
fleischlaberl|n
flex|e
fliegenglas|uer
flirt|s
floh|ue
flop|s
flor|e
flora|-1en
fluch|ue
flug|ue
flugbenzin|e
flugkorridor|e
flugstaub|ue
fluidum|-2a
flur|e
fluss|ue
fluß|=Flüsse
flusstal|uer
flußtal|uer
flusswasser|u
flutlicht|er
flügelmutter|n
flügelnuß|=Flügelnüsse
fm|
fokus|se
fond|s
fonds|
fondue|s
font|s
foodie|s
football|s
fort|s
fossil|=Fossilien
fotofinish|s
foton|en
fotz|en
foul|s
fourgon|s
foyer|s
fötus|-2en
frachtzug|ue
fragewort|uer
framework|s
franc|s
frankolin|e
frau|en
frauenfuß|ue
freak|s
freibad|uer
freier|
freigeist|er
freistoss|ue
fremdkapitalzins|=..en
fremdwort|uer
fresko|-1en
fressflash|s
friedensprozeß|=Friedensprozesse
friedensschluß|=Friedensschlüsse
friedhof|ue
frikassee|s
friseur|e
frl.|
frollein|s
frontbogen|u
frontend|s
frontvorsprung|ue
frosch|ue
frost|ue
frotteur|e
frucht|ue
früchtetee|s
frühlingsstrauss|ue
fuchs|ue
fuchsbau|e
fuchshai|e
fuchsschwanz|ue
fugen-s|
fulleren|e
funktionsabschluß|=Funktionsabschlüsse
funktionswort|uer
furz|ue
fuss|ue
fuß|ue
fussballfan|s
fußballfan|s
fussnotenapparat|=Fussnotennapparate
futon|s
future|s
fügewort|uer
füllmaterial|=Füllmaterialien
fürstabt|ue
fürstbistum|uer
fürstenthum|uer
fürstenthumb|uer
fürstentum|uer
fürtuch|uer
fürwort|uer
gacki|e
gag|s
galápagos-pinguin|e
galgant|e
galgenstrick|e
galicier|
gallier|
gambit|s
game|s
gametophyt|en
gamut|s
gang|ue
gangbang|s
ganglicht|er
ganglion|-2en
gans|ue
gänsefuß|ue
gänsehautmoment|e
gaop|s
garaus|
garten|u
gartenrotschwanz|ue
gasballon|s
gast|ue
gasthof|ue
gastmahl|uer
gastritis|=Gastritiden
gaststar|ue
gate|s
gau|e
gaul|ue
geäse|
gebäu|e
gebäude|
gebilde|
gebinde|
gebirge|
gebirgspaß|=Gebirgspässe
gebläse|
gebräu|e
gebrauch|ue
gebund|ue
geburtenüberschuß|=Geburtenüberschüsse
geburtstagsstrauss|ue
gedankenursprung|ue
gedenkblock|ue
gedränge|
geek|s
gefahrgut|uer
gefälle|
gefilde|
gefolge|
gefüge|
gegenstandswort|uer
gegenwort|uer
gegenzug|ue
gehänge|
gehäuse|
gehege|
geheimrat|ue
geheimtip|s
gehöfte|
geier|
geist|er
geisterrad|uer
geisterzug|ue
gekröse|
gelage|
gelände|
gelbaugenpinguin|e
gelbbleierz|
gelbton|ue
geld|er
geldabfluß|=Geldabflüsse
geldzufluß|=Geldzuflüsse
gelege|
geleise|
geleite|
geleitzug|ue
gelenkbus|se
gelübde|
gemach|uer
gemälde|
gemeinderat|ue
gemeingut|uer
gemenge|
gemengelage|n
geminipartus|se
gemüse|
gemüt|er
gemüth|er
gen|e
gender-gap|s
generalablaß|=Generalablässe
generalabonnement|s
generalbaß|=Generalbässe
generale|=Generalien
generalgouverneur|e
generalleutnant|s
generalmajor|e
generationenkluft|en
generikum|-2a
genesis|-2en
genickschuß|=Genickschüsse
genie|s
genital|=Genitalien
genitale|=Genitalien
genius|-2en
genotyp|en
genre|s
gentleman|-2en
genus|=Genera
genuss|ue
genuß|=Genüsse
georgier|
gepräge|
ger|e
gerichtsbeschluß|=Gerichtsbeschlüsse
gerichtshof|ue
gerichtssaal|=Gerichtssäle
gerippe|
geruch|ue
gerundivum|-2a
ges|
gesamtbetrag|e
gesamtdrehimpuls|
gesamtkapital|=Gesamtkapitalien
gesamtmasse|
gesamtumsatz|e
gesang|ue
gesäuge|
geschäftsabschluß|=Geschäftsabschlüsse
geschäftsklima|e
geschick|e
geschiebe|
geschirrtuch|uer
geschlecht|er
geschlechtswort|uer
geschmack|uer
geschmäckle|
geschmeide|
geschwist|er
gesellschaftstanz|ue
gesicht|er
gesichtsnerv|en
gesichtsvorsprung|ue
gesichtszug|ue
gesinde|
gespenst|er
gestade|
gestank|ue
gestüpp|en
getreide|
getriebe|
geusenwort|uer
gewand|uer
gewebe|
gewehrschuß|=Gewehrschüsse
gewerbe|
gewese|
gewinde|
gewinnverwendungsbeschluss|e
gewölbe|
gewölle|
gezähe|
gf|
gfrast|er
gfrieß|er
gibbon|s
gibibyte|s
gif|s
gig|s
gigawatt|
gilbhart|
gingan|s
gingivitis|=Gingivitiden
gipfeli|
girl|s
gis|
gk|
glaskolben|e
glefenrad|uer
gleitsichtglas|uer
glevenrad|uer
glied|er
globin|e
globulin|e
glockenguß|=Glockengüsse
gluon|en
glutathion|e
glücksklee|s
glücksrad|uer
glühwurm|uer
glykogen|e
gnadenschuß|=Gnadenschüsse
gnat|s
goalie|s
goatee|s
gobelin|s
goi|=Gojim
goldfaden|u
goldschatz|ue
goldschopfpinguin|e
golem|s
gollum|s
gondoliere|-1i
gotin|nen
gott|uer
gottesacker|u
gourmet|s
gouvernement|s
gouverneur|e
gönnjamin|s
gör|en
götti|
grab|uer
graben|u
grabtuch|uer
grapefrucht|en
grapefruit|s
graphen|e
gras|uer
grauwasser|u
graveur|e
graviton|en
green|s
greencard|s
grenzfluß|=Grenzflüsse
grenzzaun|e
griessbrei|e
grießbrei|e
grill|s
groove|s
gros|se
groß-hertzogthum|uer
großbetrieb|=Großbetrieb-e
großcousin|s
großfürstenthum|uer
grossfürstentum|uer
großfürstentum|uer
grossherzogthum|uer
großherzogthum|uer
grossherzogtum|uer
großherzogtum|uer
größenvorteil|=Größenvorteil-e
gruftie|s
grummet|s
grund|ue
grundgehalt|er
grundmaterial|=Grundmaterialien
grundton|ue
grundtyp|en
grundwort|uer
gruss|ue
gruß|ue
grün|s
gründungsprivileg|=Gründungsprivilegien
grünland|e
gsg|
gulag|s
gummiringerl|e
gurkenglas|uer
guss|ue
guß|=Güsse
gut|uer
güterzug|ue
gym|s
gyros|
h*ntern|
haarwasser|u
habitué|s
habitus|
habub|s
hack|s
hadron|en
hafen|u
haferbrei|e
häferl|
haftungsausschluß|=Haftungsausschlüsse
hagebuttentee|s
haggis|
hahn|ue
hahnenfuß|ue
hahnenschrei|e
hahnrei|e
hai|e
halbfinale|
halblicht|er
halbmetallcharakter|e
halbton|ue
hallenbad|uer
halloween|s
halluzinogen|e
halogen|e
hals|ue
halstuch|uer
hämerythrin|e
hammelsprung|ue
hammerhai|e
hämocyanin|e
hamsterrad|uer
hand|ue
handel|u
handelsgut|uer
handelsstopp|e
handelsüberschuß|=Handelsüberschüsse
handicap|s
handkuß|=Handküsse
handout|s
handtuch|uer
handvoll|
hang|ue
hantavirus|-2en
hanzi|
hànzì|
hapaxlegomenon|-2a
happening|s
happy-end|s
happyend|s
haratin|
hardcore|s
harem|s
harnleiter|
harnzwang|e
hartung|e
hasardeur|e
haschee|s
hascher|u
haselnuß|=Haselnüsse
hasenfuß|ue
häsin|nen
haubenpinguin|e
haudrauf|s
haupt|uer
hauptton|ue
hauptwort|uer
hauptzug|ue
haus|uer
häus'l|
hausanschluß|=Hausanschlüsse
hausbank|en
hausbar|s
hausbau|=Hausbauten
hausflur|e
haushaltsausschuß|=Haushaltsausschüsse
häusl|
häusle|
hausrotschwanz|ue
haut|ue
hautschutz|
hawara|
headset|s
heap|s
heck|s
heer|e
heerzug|ue
heidentum|uer
heiland|e
heilbad|uer
heiligtum|uer
heinz|en
heirath|en
heiratsgut|uer
heliodor|e
heliumballon|s
hellbraun|
helling|en
hellrot|
helvetier|
hemd|en
hendiadyoin|
henry|
hepatitis|=Hepatitiden
herbststrauss|ue
heringshai|e
herkunft|ue
hermelin|e
heros|-1en
herrengedeck|e
hertz|
hertzog|ue
hertzogthum|uer
herzblatt|e
herzog|ue
herzogthum|uer
herzogtum|uer
heterocyclus|-2en
heuboden|
hexen|e
hexenschuß|=Hexenschüsse
highlight|s
hilfsgut|uer
hilfswort|uer
himmelblau|
hin|
hinkunft|ue
hinterhof|ue
hinterland|e
hintern|
hinterrad|uer
hinweisschild|er
hippie|s
hippocampus|-2i
hippokampus|-2i
hiragana|
hirnwurm|uer
hirschkuh|ue
his|
histamin|e
hit|s
hitzeindex|=Hitzeindizes
hitzeschild|er
hoatzin|e
hobbit|s
hoch|s
hochära|-1en
hochbau|=Hochbauten
hochdruck|e
hochgeschwindigkeitszug|ue
hochglanzmagazin|e
hochrad|uer
hochschulabschluß|=Hochschulabschlüsse
hochsprung|ue
hof|ue
hofrat|ue
hohlspitzgeschoß|=Hohlspitzgeschosse
hokuspokus|se
holding|s
hollandrad|uer
holocaust|s
holtz|uer
holz|uer
holzfaß|=Holzfässer
holzhammer|u
holzwurm|uer
holzschlag|e
homburg|s
homepage|s
homoglyph|en
honk|s
hoodie|s
hook|=Höke
hooligan|s
horn|uer
hornung|e
hosting|s
hotel|s
hotelier|s
hotline|s
hox-gen|e
hörsaal|=Hörsäle
hps|
hs|
hsspf|
huan|s
hub|ue
huhn|uer
humboldt-pinguin|e
humor|e
hundefriseur|e
hundshai|e
hungersnot|ue
hungertuch|uer
huskarl|s
hut|ue
hutschnur|ue
hühnerei|er
hydrazin|e
hydridion|
hydroxychinolin|e
hydroxylamin|e
hype|s
hyperbaton|-2a
hyperon|en
hypnotikum|-2a
ibis|se
icon|s
id|s
ikonoklasmus|-2en
iltis|se
image|s
imageboard|s
immergrün|e
immunglobulin|e
immunsuppressivum|-2a
impeachment|s
importeur|e
incel|s
incentive|s
incubus|-2i
indier|
indiz|=Indizien
indonesier|
inflationsdruck|e
informationssektor|e
infrarot|s
infrarotlicht|er
ingenieur|e
ingrediens|=Ingredienzien
inhaltswort|uer
initialwort|uer
inkreisradius|-2en
inlandskaufkraft|en
innendekorateur|e
innenhof|ue
innenohr|en
innovationskraft|en
innovationszwang|e
insect|en
insekt|en
installateur|e
instanzenzug|ue
instrukteur|e
intensivmedizin|en
interferometrie|
interim|s
internetanschluß|=Internetanschlüsse
internetblog|s
interrobang|s
interview|s
intimus|-2i
intranet|s
investitionsklima|e
investitionsstau|e
investment|s
investmentbank|en
iodthyronin|e
ion|en
ionenradius|-2en
irin|nen
irrthum|uer
irrtum|uer
ismus|-2en
isomer|e
isthmus|-2en
ja|
jabot|s
jackpot|s
jagdschloß|=Jagdschlösser
jahresabschluß|=Jahresabschlüsse
jahresamt|uer
jahresfehlbetrag|e
jahresüberschuß|=Jahresüberschüsse
jambus|-2en
jargon|s
jasmin|e
jaspis|se
jausen|
jeans|
jecke|s
jeep|s
jein|s
jet|s
jetlag|s
jeton|s
jibbit|s
jibit|s
jingle|s
job|s
jockei|s
jodhpur|s
johannes|se
joint|s
joke|s
jokus|se
jongleur|e
jordanier|
jorts|
joule|
joystick|e
judas|se
judenrat|ue
judensau|ue
jugendamt|uer
julei|s
julklapp|s
jumbojet|s
jumpsuit|s
jungfernkranz|ue
jungsband|s
junkie|s
junktim|s
jupe|s
jurassier|
justizausschuß|=Justizausschüsse
justizirrtum|uer
jüdin|nen
jütin|nen
kabeljau|e
kabelzug|ue
kabinettsrat|ue
kabochon|s
kabriolett|s
kadaverin|e
kaffee|s
kaffeepad|s
kaffer|n
kahn|ue
kaiserpinguin|e
kaiserthum|uer
kaisertum|uer
kaktus|=Kakteen
kalabrier|
kalaschnikow|s
kalb|uer
kaledonier|
kalifornienkondor|e
kalifornier|
kaliglimmer|e
kameel|e
kamel|e
kamillentee|s
kamm|ue
kammerton|ue
kamp|ue
kampf|ue
kampfjet|s
kanadier|
kanal|ue
kanapee|s
kaninchenbau|e
kanon|s
kantineur|e
kantönli-geist|er
kantönligeist|er
kanzleramt|uer
kap|s
kapital|=Kapitalien
kapitalabfluß|=Kapitalabflüsse
kapitalisierungszins|e
kapitalumschlag|e
kapitalzufluß|=Kapitalzuflüsse
kaplan|ue
karabinerverschluß|=Karabinerverschlüsse
kardinal|ue
karree|s
kartoffelbrei|e
karyotyp|en
käs|en
käse|
kassa|-1en
kassabon|s
kassamarkt|e
kassenbon|s
kastanienbraun|
käste|
kasten|u
kastenwagen|u
kasus|
kat|s
katakana|
katoforite|=Katforiten
katzenhai|e
katzensprung|ue
kauf|ue
käufermarkt|e
kauz|ue
kd|
kebab|s
kebap|s
keffije|s
kefije|s
kefiye|s
kehrdruck|e
kek|s
kelvin|
kenntniß|=Kenntnisse
kennwort|uer
kerndisziplin|en
kernmaterial|=Kernmaterialien
kerzenlicht|er
kettfaden|u
keyboard|s
kgv|
khk|
ki|s
kibibyte|s
kick|s
kid|s
kiddie|s
kiefernast|ue
kiel|e
kilowatt|
kind|er
kinderrad|uer
kinderstar|s
kindesnot|ue
kinosaal|=Kinosäle
kipfel|n
kipfl|n
kippah|s
kirchenchor|ue
kirchhof|ue
kirmes|=Kirmessen
kirschenwasser|u
kirschwasser|u
kk|
kl|
klan|s
klang|ue
klapprad|uer
klavikula|e
klebrand|uer
kleid|er
kleingeist|er
klettverschluß|=Klettverschlüsse
klick|s
klientel|en
klimastreik|s
klimmzug|ue
klingelton|ue
klischee|s
klitikon|-2a
klitoris|=Klitorides
klobassi|
klonus|-2i
kloß|ue
kloster|u
klotz|ue
klub|s
kluft|ue
klumpenrisiko|e
klumpfuß|ue
kluntje|s
knackarsch|ue
knast|ue
knauf|ue
kneipier|s
knickbus|se
knicklicht|er
knigge|
knochenjob|s
knochentumor|e
knock-out|s
knopf|ue
knopp|ue
koch|ue
kode|s
kofferwort|uer
kok|
koka|
kokosnuß|=Kokosnüsse
kollaborateur|e
kollagen|e
kollektivum|-2a
kollier|s
komitee|s
kommandeur|e
kommendatarabt|ue
komment|s
kommentur|e
kommis|
kommunikee|s
kommuniqué|s
kompagnon|s
kompass|e
komplet|s
kompott|e
kompromat|s
komtur|e
kondor|e
kondukteur|e
konfetti|
kongofluß|=Kongoflüsse
konjunkturabschwung|e
konjunkturaufschwung|e
konjunkturrückgang|e
konkretum|-2a
konstrukteur|e
konsul|n
konsum|s
konsumgut|uer
konsumklima|e
kontinent|e
kontinuativum|-2a
konto|-1en
kontrabaß|=Kontrabässe
kontrolleur|e
kontrollor|e
konvent|e
konzertsaal|=Konzertsäle
koog|=Köge
kopf|ue
kopfgrind|e
kopfnuß|=Kopfnüsse
kopftuch|uer
kopfwort|uer
kopp|ue
kor|
kora|
korb|ue
kordon|s
korn|uer
korona|-1en
korporale|=Korporalien
korps|
korpus|se
korridor|e
kosmetikum|-2a
kosmos|-2en
kölschkranz|ue
königsgelb|s
königspinguin|e
königsschloß|=Königsschlösser
königthum|uer
königtum|uer
körperbau|e
kp|=Kaufpreise
kptbs|
kr|
krach|ue
krad|uer
krafft|ue
kraft|ue
kraftrad|uer
krähenfuß|ue
kramm|en
krampf|ue
krampus|se
kranichzug|ue
krankenkassa|en
kranz|ue
kratzfuß|ue
kraut|uer
kräutertee|s
kreateur|e
krebsmedizin|en
kreditausfall|e
kreditausfallswap|s
kredithai|e
kreditrisiko|e
kreisbogen|u
kreißsaal|=Kreißsäle
krem|s
kreml|
kreol|s
kreuzzug|ue
kriegsrat|ue
kriegstuba|-1en
kriminalamt|uer
krisenmanagement|s
krisis|-2en
kristall|e
kristallglas|uer
krokus|se
kronenpinguin|e
kronrat|ue
kropf|ue
krösus|se
krug|ue
krypta|-1en
ksg|s
kuckucksei|er
kuh|ue
kuhfladen|
kulturgut|uer
kulturwort|uer
kummerbund|e
kumquat|s
kumulonimbus|se
kumulus|-2i
kunst|ue
kunstwort|uer
kupee|s
kupon|s
kurbad|uer
kurfürstenthum|uer
kurfürstentum|uer
kuriosum|-2a
kurkuma|-1en
kursaal|=Kursäle
kurseinbruch|e
kursrückgang|e
kurssprung|e
kursus|-2e
kurvenmaximum|-2a
kurvenminimum|-2a
kurzwort|uer
kurzzug|ue
kurzschluß|=Kurzschlüsse
kuseng|s
kuss|ue
kuß|=Küsse
kustos|=Kustoden
kuvert|s
kühlgut|uer
künsteley|en
künstlertuch|uer
kürbis|se
label|s
lächeln|
lachshai|e
laden|u
lag|s
lagewort|uer
lahar|s
laienabt|ue
laiin|nen
lallwort|uer
lamm|uer
lämmerschwanz|ue
land|uer
landei|er
landesbank|en
landesrat|ue
landgut|uer
landrat|ue
landratsamt|uer
langschwanzpinguin|e
lat|s
lauf|ue
laufpaß|=Laufpässe
laufrad|uer
laus|ue
läuseei|er
lausei|er
lavafluß|=Lavaflüsse
lavaret|s
lawra|-1en
layout|s
leak|s
lebensfaden|u
lebenswasser|u
lebewohl|s
lebkuchenherz|en
leck|s
led|s
leergut|uer
leerwort|uer
lehnwort|uer
lehramt|uer
lehrmaterial|=Lehrmaterialien
leib|er
leichentuch|uer
leichenzug|ue
leichtbau|=Leichtbauten
leichtfuß|ue
leier|n
leierschwanz|ue
leintuch|uer
leistungsbonus|se
leitfaden|u
leitton|ue
leitungsband|e
leitzins|e
lektin|e
lelek|s
lellek|s
lemma|=Lemmata
lemniskate|n
lenkungsausschuß|=Lenkungsausschüsse
lenz|e
leopardenhai|e
leprechaun|s
lepton|en
lesbier|
lesesaal|=Lesesäle
leucin|e
leukotrien|e
leukoxen|e
liaison|s
lid|er
lied|er
liederkranz|ue
liegerad|uer
liesch|en
liga|-1en
lignin|e
lilienstrauss|ue
limoncello|-1i
lindenblütentee|s
lindwurm|uer
link|s
liquiditätsengpass|e
litewka|-1en
lithiumamalgam|e
lithophyt|en
litotes|
lkd|
location|s
loch|uer
lockdown|s
lockwort|uer
loft|s
logarithmus|-2en
logfile|s
loggia|-1en
lohn|ue
lohngefälle|n
lohnniveau|e
lok|s
lokalmatador|e
lokalredakteur|e
look|s
loop|s
lorbeerkranz|ue
lord|s
lotos|
lotus|
lounge|s
löwenfuß|ue
löwenherz|en
löwin|nen
lpd|
lr|
luft|ue
luftabschluß|=Luftabschlüsse
luftibus|se
luftikus|se
luftröhrenast|ue
luftschloß|=Luftschlösser
luftzug|ue
luminophor|e
luntenschloß|=Luntenschlösser
lust|ue
lustschloß|=Lustschlösser
lux|
luxusgut|uer
luxuszug|ue
lyra|-1en
lysosom|en
m*sch*|s
maas|se
macadamianuß|=Macadamianüsse
macaron|s
macht|ue
macron|-2a
madame|=Mesdames
madeleine|s
madenwurm|uer
mädle|
mafioso|-1i
magazin|e
magd|ue
magellan-pinguin|e
magen|u
magier|
magistra|e
mai|e
maisfladen|
maisonette|s
maitli|
majolika|-1en
major|e
make-up|s
makramee|s
makrelenhai|e
makron|-2a
malaysier|
malware|s
management|s
mandarin|e
mandola|-1en
mandorla|-1en
manganocen|e
mangel|u
mann|uer
mannequin|s
männerchor|ue
männerfuß|ue
mantel|u
mantilla|-1en
manul|s
manuskript|e
marasmus|-2en
margarodit|en
marienbad|uer
marienglas|uer
mark|
markör|s
markt|ue
marktabschwung|e
marktaufschwung|e
marktmacht|en
marktstillstand|e
marktzugang|e
marmor|e
marodeur|e
maroni|
marquis|
marroni|
marsch|ue
marschall|ue
marshmallow|s
marxistin-leninistin|=Marxistinnen-Leninistinnen
maskulinum|-2a
masseur|e
mastek|s
mastermind|s
mastodon|=Mastodonten
match|=Matches
material|=Materialien
matjes|
matt|s
matura|-1en
mauerbau|=Mauerbauten
mauervorsprung|ue
maul|uer
mauretanier|
maus|ue
mausohr|en
mauspad|s
mauß|u-1se
maximum|-2a
mazedonier|
mäzen|e
mebibyte|s
medaillon|s
medicane|s
medizin|en
meer|e
meeting|s
megawatt|
mehrkanalvertrieb|=Mehrkanalvertrieb-e
mehrwegglas|uer
mehrwegpfand|uer
mehrwertsteuerbetrug|e
meier|
meinungskorridor|e
meitschi|
melanzani|
melkkuh|ue
meme|s
ménage-à-trois|
meningitis|=Meningitden
meniskus|-2en
menora|
menorah|
mensa|-1en
mensch|er
menschenfuß|ue
menü|s
mercedes|se
mercedes-benz|
merk|s
merlot|s
meson|en
message|s
messerfuß|ue
messias|se
messie|s
mesusa|=Mesusot
metallfaß|=Metallfässer
metallgeschmack|ue
metallocen|e
metallschraubverschluß|=Metallschraubverschlüsse
methamphetamin|e
methusalem|s
metier|s
metropolis|-2en
metteur|e
miethai|e
mikromol|
mikronesier|
mikrotubulus|-2i
milchbar|s
milchglas|uer
milchkuh|ue
milchshake|s
militär|s
militärdoktrin|en
militärgouverneur|e
mille|
millikelvin|
mimin|nen
mindmap|s
mineur|e
minimum|-2a
minivan|s
minus|se
miss|=Misses
mitochondrion|-2a
mitra|-1en
mittelbau|e
mittelfuß|ue
mittelohr|en
mittelwort|uer
moai|
mob|s
mobile|s
mocktail|s
mod|s
model|s
modewort|uer
modus|-2i
mokassin|s
mokscha|
mol|
molybdänmangel|
molybdopterin|e
mom|s
moment|e
monteur|e
monumentalbau|=Monumentalbauten
mop|s
moped|s
mopp|s
mopped|s
mops|ue
mora|-1en
morbus|-2i
mordent|e
morgentau|e
motel|s
motorfuchsschwanz|ue
motorrad|uer
mottek|s
mountainbike|s
mowl|=Mäuler
mönchsthum|uer
mönchthum|uer
mpu|s
muchtar|s
mudda|=Müdda
muffin|s
mufflon|s
mullah|s
multikulti|
multitab|s
mum|s
mummenschanz|e
mund|uer
mundvoll|
mundwasser|u
mural|s
musche|s
musical|s
muskatnuß|=Muskatnüsse
muskel|n
muskul|n
musselin|e
must-have|s
mustang|s
mutagen|e
mutter|u
mutterkorn|e
mühlrad|uer
mva|s
myiasis|=Myiases
myokarditis|=Myokarditiden
myon|en
mythos|-2en
mythus|-2en
myzel|=Myzelien
nabelschnur|ue
nachbau|=Nachbauten
nachdruck|e
nachfragerückgang|e
nachlass|ue
nachlaß|=Nachlässe
nacht|ue
nachtlicht|er
nachtrag|ue
nachtzug|ue
nachweisreagenz|=Nachweisreagenzien
nacktnasenwombat|s
nagel|u
nähfaden|u
naht|ue
namaste|s
namensschild|er
namensursprung|ue
namenwort|uer
namibier|
nanobot|s
nanomaterial|=Nanomaterialien
nanomedizin|en
nanowatt|
napf|ue
narkotikum|-2a
nastuch|uer
natel|s
natronsalpeter|e
nebenfluß|=Nebenflüsse
nebenjob|s
nebennierenmark|e
nebenton|ue
nebenwort|uer
necessaire|s
nécessaire|s
negligé|s
négligé|s
negligee|s
nelkenstrauss|ue
nennwort|uer
nerd|s
nessessär|s
nest|er
netsch|
nettogehalt|er
nettolohn|e
nettoumsatz|e
neubau|=Neubauten
neudruck|e
neuroleptikum|-2a
neustart|s
neutron|en
neutronenüberschuß|=Neutronenüberschüsse
newton|
nickelin|e
niederkunft|ue
niederland|e
niederrad|uer
nierenglomerulus|-2i
nierentubulus|-2i
nike|s
nomadentum|uer
nominallohn|e
nominallohnstopp|e
nonnenfürzle|
noob|s
nordlicht|er
not|ue
notebook|s
notenbank|en
notepad|s
noth|ue
notierungssprung|e
notizblock|ue
nps|
nucleotid|en
nukleon|en
nukleus|-2i
numerus|-2i
nummernschild|er
nusairier|
nuss|ue
nuß|=Nüsse
nutzungsszenario|e
nutzvieh|=Nutzviecher
nylon|s
o-saft|ue
ob|s
obazda|-1en
obergespan|e
oberleitungsbus|se
oberton|ue
obfrau|en
obliquus|-2i
octen|e
oesophagospasmus|-2en
ofen|u
office|s
ogonek|s
ohnmacht|en
ohr|en
ohrmutter|n
ohropax|
ohrwurm|uer
olefin|e
oleum|-2a
olivenhain|e
olivin|e
olympiastadion|-2en
olympier|
omikron|s
omnibus|se
onboarding|s
one-night-stand|s
onigiri|
onomatopoetikum|-2a
ons|
onus|=Onera
operateur|e
operationssaal|=Operationssäle
opossum|s
optimum|-2a
optionsmarkt|e
oralsex|en
orang-utan|s
orangenhain|e
oranier|
orbit|s
orderbuch|e
ordnungsamt|uer
organophosphin|e
orgasmus|-2en
ork|s
ortsschild|er
os|=Ossa
osterei|er
ostern|
osterstrauss|ue
oud|s
oukie|s
outcome|s
outfit|s
outing|s
outlaw|s
overall|s
oxymoron|-2a
oxytonon|-2a
ozelot|s
ozonidanion|e
ölbaum|ue
ölbild|er
ölfass|uer
ölfaß|=Ölfässer
ölfeld|er
ölgemälde|
ölstand|ue
önophiler|-1n
öre|
ösophagospasmus|-2en
ösophagus|-2i
östrogen|e
pahlstek|s
pak|s
palais|
palankin|e
palas|se
palast|ue
palästinensertuch|uer
paletot|s
palituch|uer
palstek|s
panaché|s
panaschee|s
pancake|s
paneel|e
panel|s
pangasius|-2en
pankreas|=Pankreaten
panorama|-1en
pantheon|s
panz|u
panzerglas|uer
paparazzo|-1i
pappmaché|s
pappmaschee|s
papst|ue
papyrus|-2i
paradiddle|s
paradiesnuß|=Paradiesnüsse
paradigma|-1en
paradoxon|-2a
paraffin|e
paralipomenon|-2a
paranoia|-1en
paranuß|=Paranüsse
parchent|e
parcours|
parfum|s
park|s
parlamentsausschuß|=Parlamentsausschüsse
parlamentsbeschluß|=Parlamentsbeschlüsse
paroxysmus|-2en
parsec|
parteiausschluß|=Parteiausschlüsse
parteitagsbeschluß|=Parteitagsbeschlüsse
parterre|s
partizip|=Partizipien
partyband|s
parvenü|s
pascal|
pass|ue
paß|=Pässe
passus|
passwort|uer
paßwort|uer
pasta|-1en
pastellton|ue
patchwork|s
patella|-1en
patentamt|uer
path.|
patin|nen
patissier|s
patrizier|
patronymikon|-2a
patronymikum|-2a
patt|s
pav|
pavillon|s
paywall|s
pb|s
pd|
peak|s
pebibyte|s
pedelec|s
pekannuß|=Pekannüsse
peloton|s
pendant|s
pendentif|s
penizillin|e
pennsylvanier|
penten|e
penthouse|s
penny|=Pence
peperoncino|-1i
pepsin|e
performance|s
periastron|-2a
perihel|e
perikarditis|=Perikarditiden
periodicum|-2a
periodikum|-2a
perispomenon|-2a
peroxisom|en
perron|s
personalaufbau|e
personenwagen|u
personenzug|ue
pescher|=Pescharim
petabyte|s
petschaft|e
petting|s
pfahl|ue
pfahlbau|=Pfahlbauten
pfandgeld|=Pfandhgelder
pfefferminztee|s
pfeffernuß|=Pfeffernüsse
pfefferoni|
pfeilschuß|=Pfeilschüsse
pferdefuß|ue
pferdekuß|=Pferdeküsse
pferdeschwanz|ue
pflanzenmilch|e
pflock|ue
pflug|ue
pfrnak|s
pgh|s
phänomen|e
phänotyp|en
pharao|nen
pharaoh|nen
pharm.|
pharmakon|-2a
pharmazeutik|a
pharynx|=Pharyngen
phenanthrolin|e
philippika|-1en
pho|
phosphazen|e
phosphin|e
photon|en
phönizier|
physikus|se
pickerl|
pickup|s
pidgin|s
piercing|s
pietà|s
pils|
pin|s
ping|s
pinguin|e
pink|s
pipeline|s
pippau|e
pique|s
pistol|en
pj|
plädoyer|s
plaid|s
plan|ue
planwagen|u
plaque|s
plasma|-1en
plastikschraubverschluß|=Plastikschraubverschlüsse
plastikschwanz|ue
plattenbau|=Plattenbauten
plattfuß|ue
plattwurm|uer
platz|ue
platzierungsrisiko|en
plausch|ue
play-off|s
pleitier|s
plenarsaal|=Plenarsäle
plenk|s
pleonasmus|-2en
plexiglas|uer
plissee|s
plunder|n
pluralwort|uer
pluviale|
pm|
podcast|s
poetry-slam|s
pohl|ue
polarlicht|er
pole-position|s
policinello|-1i
polier|
polierstahl|ue
polin|nen
polis|=Poleis
politikum|-2a
poltergeist|er
polyethylen|e
polymer|e
polyolefin|e
polypropylen|e
polysyndeton|-2a
pommes|
pompon|s
ponton|s
ponyhof|ue
pool|s
pop-up|s
popanz|e
popsch|ue
popstar|s
por|
pornostar|s
porphyrin|e
porree|s
porrei|s
portefeuille|s
portemonnaie|s
portepee|s
portfolioumsatz|=Portfolioumsatz-e
portfolioumschlag|=Portfolioumschlag-e
portmonee|s
portrait|s
porträt|s
posaunenchor|ue
poseur|e
positron|en
postamt|uer
postillion|e
postskriptum|-2a
pott|ue
pottsau|ue
poule|s
poulet|s
powidl|
pr|
präbiotikum|-2a
prachtstaffelschwanz|ue
prädikativum|-2a
praeteritio|nen
prahlhans|ue
praktikum|-2a
praliné|s
pralinee|s
prank|s
präpositionaladverb|=Präpositionaladverbien
präteritum|-2a
präventivschlag|e
praxis|-2en
preisschild|er
premier|s
presslufthammer|u
priapswurm|uer
priel|e
priesterthum|uer
priestertum|uer
prima|-1en
primadonna|-1en
primarius|-2en
primärmarkt|e
primärsektor|e
primas|se
primus|-2i
princeps|=Principes
princip|=Principien
prinzeps|=Prinzipes
prisma|-1en
privatchat|s
privatier|s
privatjet|s
probiotikum|-2a
procedere|
produktlebenszyklus|se
prof|s
profess|e
profeß|=Professe
profiteur|e
programmierprinzip|=Programmierprinzipien
prokura|-1en
proll|s
promille|
prompt|s
pronom|en
pronominaladverb|=Pronominaladverbien
propst|ue
prostata|e
prostylos|-1i
protegé|s
protest|e
protestzug|ue
proton|en
prototyp|en
protozoon|-2en
proviant|e
provokateur|e
prozedere|
prunksaal|=Prunksäle
prüfungstermin|e
psa|en
psalm|en
pseudoskorpion|e
psoriasis|-2en
psychedelikum|-2a
psychopompos|-1i
ptosis|-2en
pua|e
publicum|-2a
puck|s
pud|
pulcinella|-1e
pulverfaß|=Pulverfässer
pumpgun|s
pumps|
punk|s
pushback|s
putt|s
putto|-1i
putztuch|uer
puzzle|s
püree|s
pyrazin|e
pyrochlor|e
pyroxen|e
pyrrhotin|e
python|s
pz|s
pzb|s
qark|=Qarqe
quadratfuß|
quadriga|-1en
quälgeist|er
quant|en
quantensprung|ue
quarkonium|-2a
quarta|-1en
quartärsektor|e
quarzglas|uer
qubit|s
queen|s
queer|s
quellfluß|=Quellflüsse
querschuß|=Querschüsse
quetzal|s
queue|s
quickie|s
quinta|-1en
rachsucht|ue
racket|s
raclette|s
rad|uer
radl|n
radsturz|ue
ragout|s
rakett|s
rallye|s
rampenlicht|er
rampensau|ue
rand|uer
randale|
ranft|ue
rang|ue
rank|ue
rant|s
rap|s
raptus|
rasthof|ue
rat|ue
ratatouille|s
rath|ue
ratschluß|=Ratschlüsse
rattenschwanz|ue
raubdruck|e
raubzug|ue
rauchglas|uer
raum|ue
raumnot|ue
rausch|ue
rautenkranz|ue
rave|s
razzia|-1en
reagenz|=Reagenzien
reagenzglas|uer
reallohn|e
reaumur|
rechaud|s
rechnungshof|ue
rechtsausschuß|=Rechtsausschüsse
rechtssprichwort|uer
redakteur|e
redaktionsschluß|=Redaktionsschlüsse
ref|s
ref.|
referee|s
referenzzinssatz|e
reflexivum|-2a
refrain|s
regenguß|=Regengüsse
regent|s
regenwasserfaß|=Regenwasserfässer
regenwurm|uer
regierungsbeschluß|=Regierungsbeschlüsse
regierungsrat|ue
regime|
regisseur|e
reglement|s
reichsgau|e
reichsparteitag|=Reichspartage
reichsrat|ue
reichthum|uer
reichtum|uer
reinigungstuch|uer
reisebus|se
reisekönigtum|uer
reisepaß|=Reisepässe
reißverschluß|=Reißverschlüsse
rekommandeur|e
rektum|-2a
relais|
release|s
relief|s
remake|s
rendezvous|
rennrad|uer
renommee|s
rep|s
repertoire|s
requiem|s
requiemhai|e
requisit|en
reserverad|uer
resonator|e
resort|s
ressentiment|s
ressort|s
resümee|s
retardierungsproblem|
retikulum|-2a
retina|e
rettungswagen|u
retweet|s
revers|
review|s
revirement|s
rhema|=Rhemata
rhinitis|=Rhinitiden
rhinozeros|se
rhodamin|e
rhodinieren|e
rhododendron|-2en
rhombus|-2en
rhythmus|-2en
rial|s
ribosom|en
richtblock|ue
richtschnur|ue
riesenrad|uer
rind|er
rindvieh|=Rindviecher
ringelgans|en
ringerl|
ringspezies|
ringwall|ue
risikomanagement|s
rist|e
rittergut|uer
rittersaal|=Rittersäle
ritus|-2en
roadmap|s
roche|s
rock|ue
rockband|s
rohbau|e
rohmaterial|=Rohmaterialien
rohstahl|ue
rohstoffmarkt|e
rohstoffsektor|e
rokokoschloß|=Rokokoschlösser
rom|a
romancier|s
romande|s
rooibos|se
rootkit|s
rosenkrantz|ue
rosenkranz|ue
rosenstrauss|ue
rotaprint|s
rotbraun|
roth|s
rothschild|s
rotschwanz|ue
rotstirn-borstenschwanz|ue
rouge|s
roulett|s
roulette|s
routinier|s
röntgenstrahl|e
rpzb|s
rss-feed|s
rubiklin|e
ruch|ue
rumpf|ue
rumpfwort|uer
run|s
rundbau|=Rundbauten
russenmagazin|e
rutheniridosmin|e
rutschblock|ue
rübli|
rückkauf|e
rücklicht|er
rückschluß|=Rückschlüsse
rücksprung|ue
rückzug|ue
rüebli|
rührei|er
rz|s
saal|=Säle
saatbank|en
sachet|s
sack|ue
saft|ue
säkulum|-2a
salak|s
salatbar|s
salatmarinade|s
salatsauce|s
salbeitee|s
salettl|n
salon|s
salzamt|uer
salzwasser|u
samenbank|en
samin|nen
samisdat|s
samizdat|s
samurai|
sang|ue
sanktionsbeschluß|=Sanktionsbeschlüsse
sarg|ue
sarkasmus|-2en
satanas|se
satin|s
sattel|u
satz|ue
sauerstoffbar|s
sauerstoffdruck|e
saugwurm|uer
säulenfuß|ue
säulenschaft|ue
saum|ue
sauna|-1en
saurier|
schabbes|
schach|s
schacht|ue
schachzug|ue
schadchan|
schade|un
schädel-hirn-trauma|=Schädel-Hirn-Traumata
schaden|u
schaft|ue
schah|s
schal|s
schaltzug|ue
schampus|
schandmal|e
schandpreis|er
schandzeichen|e
schank|ue
scharrhans|ue
schau|en
schaub|ue
schaum|ue
scheck|s
scheibenbremssattel|
scheidekunde|
schermodul|n
schiefergrau|
schiffsrumpf|e
schl*mp*|n
schlachthof|ue
schlaf|ue
schlafsaal|=Schlafsäle
schlag|ue
schlamm|ue
schlampensau|ue
schlapphut|ue
schlappschwanz|ue
schlauch|ue
schleier|
schleifstaub|ue
schlepptau|e
schlesier|
schlitzohr|en
schloss|uer
schloß|=Schlösser
schluckauf|s
schlumpf|ue
schluss|ue
schluß|=Schlüsse
schluss-s|
schlusslicht|er
schlußlicht|er
schmarrn|
schmelzbad|uer
schmelzfluß|=Schmelzflüsse
schmerz|en
schmetterlingsverschluß|=Schmetterlingsverschlüsse
schmock|s
schmollis|
schmuggelgut|uer
schnabel|u
schnack|s
schnappschuß|=Schnappschüsse
schnaps|ue
schnatz|ue
schnellschuß|=Schnellschüsse
schnellzug|ue
schnur|ue
schokokuß|=Schokoküsse
scholion|-2en
schoos|=Schöse
schooss|=Schösse
schooß|=Schöße
schopf|ue
schopfpinguin|e
schoss|ue
schoß|ue
schott|en
schöngeist|er
schöpfergeist|er
schra|en
schram|ue
schranz|ue
schraubenmutter|n
schraubverschluß|=Schraubverschlüsse
schreckschuß|=Schreckschüsse
schrei|e
schreier|
schrifttum|uer
schriftzug|ue
schrimp|s
schrofen|
schub|ue
schuhcreme|s
schuhkreme|s
schulabschluß|=Schulabschlüsse
schulbuchverlag|e
schulbus|se
schulhof|ue
schulschluß|=Schulschlüsse
schulterschluß|=Schulterschlüsse
schuss|ue
schuß|=Schüsse
schussfaden|u
schußfaden|u
schutzwall|ue
schütteltanz|ue
schüttkasten|
schwachmatikus|se
schwadroneur|e
schwager|u
schwalbenschwanz|ue
schwamm|ue
schwammtuch|uer
schwan|ue
schwank|ue
schwanz|ue
schwänzeltanz|ue
schwanzwort|uer
schwarm|ue
schwarzbau|=Schwarzbauten
schwarztee|s
schweineohr|en
schweinsohr|en
schweißfuß|ue
schwert|er
schwesterherz|en
schwiegerschwager|
schwimmbad|uer
schwulst|ue
schwung|ue
schwungrad|uer
schwur|ue
scoop|s
screen|s
screencast|s
screening|s
screenshot|s
se|
sechswochenamt|uer
seebad|uer
seekuh|ue
seenot|ue
seeohr|en
seeskorpion|e
segelohr|en
sehnsucht|ue
seiche|s
seidenfaden|u
seidenschwanz|ue
seiltanz|ue
seitensprung|ue
sektbar|s
sekunda|-1en
sekundärmarkt|e
sekundärsektor|e
selbstdisziplin|en
selenmineral|=Selenmineralien
semaphor|e
semesterstart|s
semifinale|
sendemast|en
sendeschluß|=Sendeschlüsse
senfglas|uer
senkblei|e
separee|s
séparée|s
sepia|-1en
sepsis|-2en
serail|s
serpentin|e
service|s
set|s
sexsucht|ue
sexta|-1en
sexus|
shakehands|
sheriff|s
shiitake|
shirt|s
shitstorm|s
shooting|s
shop|s
shopping-center|s
shoppingcenter|s
shortcake|s
shortcut|s
shortlist|s
shorts|
show|s
shrimp|s
sicherheitsrat|ue
sicherheitsrisiko|-1en
sicherheitsverschluß|=Sicherheitsverschlüsse
sideboard|s
siebdruck|e
sieben|en
siegeszug|ue
silberfaden|u
silbermineral|=Silbermineralien
silicon|e
single|s
singleton|s
singrün|e
singularwort|uer
singulett|s
sinnesnerv|en
sinto|-1i
sinusitis|=Sinusitiden
sit-up|s
sitar|s
sitcom|s
sitzredakteur|e
skala|-1en
skaleneffekt|=Skaleneffekt-e
skandalon|-2a
skarabäus|-2en
skate|s
skateboard|s
skill|s
skinhead|s
skipaß|=Skipässe
sklera|-1en
skorpion|e
skript|s
skrotum|-2a
skyline|s
slalom|s
slip|s
slogan|s
slop|s
slum|s
smartcard|s
smartphone|s
smartwatch|=Smartwatches
smilodon|s
smog|s
smollis|
smombie|s
smoothie|s
snack|s
snaresinselpinguin|e
snob|s
snooker|s
snowboard|s
soap|s
softie|s
software|s
sohn|ue
soja|-1en
solei|er
solfeggio|-1en
solidaritätsprinzip|=Solidaritätsprinzipien
soliton|en
sommerstrauss|ue
sonderausschuß|=Sonderausschüsse
sonderzug|ue
song|s
sonnenbad|uer
sonnencreme|s
sonnenhut|ue
sonnenkreme|s
sonnenrad|uer
sonnentau|e
sorbet|s
sordino|-1i
sorghum|e
soufflé|s
soufflee|s
souffleur|e
souk|s
soul|
sound|s
souper|s
souterrain|e
souvenir|s
sowjet|s
sozialamt|uer
spaceshuttle|s
spam|s
span|ue
spanier|
spannungszustand|=Spannungzustände
sparring|s
spass|ue
spaß|ue
spatz|ue
spätzle|
species|
spediteur|e
speedrun|s
speer|e
speik|e
speisesaal|=Speisesäle
spekulatius|
spendengeld|e
spenderherz|en
sperrad|uer
sperrrad|uer
spessartin|e
spezialstahl|ue
spider-app|s
spiegelei|er
spiegelsaal|=Spiegelsäle
spiel|e
spielmaterial|=Spielmaterialien
spielsucht|ue
spielzug|ue
spike|s
spillbaum|=Spillbaumes
spin|s
spinnerdelfin|e
spinnfaden|u
spinnrad|uer
spion|e
spirit|s
spital|uer
spitzentanz|ue
spleen|s
splitting|s
spodumen|e
spondeus|-2en
sporophyt|en
sportherz|en
sportlerherz|en
spot|s
spottwort|uer
spracherwerb|
sprachkorpus|=Sprachkorpora
sprechchor|ue
springinsfeld|e
springschwanz|ue
sprint|s
spruch|ue
sprudelbad|uer
sprung|ue
sprühstoss|ue
sps|
spulwurm|uer
spund|ue
sputum|-2a
spülsaummaterial|=Spülsaummaterialien
spültuch|uer
staat|en
staatsamt|uer
stab|ue
stabhochsprung|ue
stachel|n
stack|en
stadion|-2en
stadl|
stadt|ue
stadtrat|ue
stadtschloß|=Stadtschlösser
staffelschwanz|ue
stahlbad|uer
stahlfaß|=Stahlfässer
stalag|s
stalingrad|s
stall|ue
stamm|ue
stammesherzogthum|uer
stammesherzogtum|uer
stammherzogthum|uer
stammherzogtum|uer
stand|ue
standard|s
standardtanz|ue
ständerat|ue
standesamt|uer
standortfaktor|e
stangenei|er
starez|=Starzen
startblock|ue
startschuß|=Startschüsse
startup|s
statement|s
stater|e
statut|en
stb|
steak|s
stearin|e
steinschloß|=Steinschlösser
stenz|e
steppke|s
stepptanz|ue
sternenstaub|ue
sternum|-2a
stetl|
steuerrad|uer
stg|
stick|s
stiel|e
stiftsherr|en
stimmensplitting|e
stimmvolk|e
stimulus|-2i
stinkadores|
stock|ue
stockbus|se
stoich.|
stola|-1en
stoma|=Stomata
stop|s
stopp|s
stoppie|s
stoppschild|er
stopschild|er
storch|ue
store|s
stoß|ue
stotz|en
stpfl.|
stracciatella|-1e
strahl|en
strahlenkranz|ue
stramin|e
strand|ue
strandbad|uer
strandgut|uer
strang|ue
strap-on|s
straß|=Strasse
strassenschild|er
straßenschild|er
strassenzug|ue
straßenzug|ue
strauch|uer
strauß|ue
stream|s
streaming|s
streckenzug|ue
streifzug|ue
streik|s
streitaxt|ue
streptokokkus|-2en
strike|s
string|s
strohhut|ue
strom|ue
stromanschluß|=Stromanschlüsse
struggle|s
strumpf|ue
studiosus|-2i
stuhl|ue
stumpf|ue
stundenglas|uer
stunt|s
sturm|ue
stützrad|uer
suada|-1en
sub|s
subbotnik|s
subkontinent|e
subspezies|
suitier|s
sujet|s
suk|s
sumpf|ue
sup|s
supernova|e
superspezies|
superstar|s
support|s
sutra|-1en
svg|s
swing|s
syllepsis|-2en
symbolbild|e
symposion|e
synesis|-2en
synopsis|-2en
synsemantikon|-2a
synsemantikum|-2a
synthesis|-2en
synthie|s
syrier|
szenar|=Szenarien
szenario|-1en
t-hemd|en
t-shirt|s
t*tt*|n
tab|s
tablet|s
tabloid|s
tachyon|en
tagbau|e
tagebau|e
tal|uer
talahon|s
taled|
talib|=Taliban
taliban|
talking-point|s
tallit|
tallith|
tambourmajor|e
tamburin|e
tampon|s
tamtam|s
tandem|s
tangens|
tank|s
tannin|e
tansanier|
tanz|ue
tanzbar|s
tanzsaal|=Tanzsäle
tara|-1en
tarnkappenjet|s
tarsus|-2en
taschentuch|uer
taskforce|s
tatentschluß|=Tatentschlüsse
tätigkeitswort|uer
tatzelwurm|uer
tauschhandel|u
tauschwert|e
tauwurm|uer
taxin|nen
taxon|-2a
tbm|
team|s
teamwork|s
tebibyte|s
tee-ei|er
teeei|er
teeglas|uer
teenie|s
teer|e
teilmantelgeschoß|=Teilmantelgeschosse
teint|s
telefonanschluß|=Telefonanschlüsse
tempolimit|s
tempus|=Tempora
tenor|ue
tenuis|=Tenues
terawatt|
termin|e
terminmarkt|e
terminus|-2i
terpen|e
terrain|s
terrier|
tertia|-1en
tertiärsektor|e
teschek|s
tesla|
test|s
tetramer|e
tetramorph|en
textil|=Textilien
thal|uer
thalamus|-2i
thallus|-2i
than|s
thee|s
thema|-1en
therapeutikum|-2a
thioether|e
thioredoxin|e
thon|s
thorn|s
thread|s
thuja|-1en
thum|e
thurm|ue
thurn|ue
thyreoiditis|=Thyreoiditiden
tiara|-1en
tibia|e
tic|s
tick|s
ticket|s
tief|s
tiefbauingenieur|e
tierzucht|ue
tigerhai|e
timbre|s
timing|s
tintenfaß|=Tintenfässer
tip|s
tipp|s
tippfehlerdomain|s
tischgedeck|e
tischtuch|uer
tmesis|-2en
toches|
tochter|u
tocktail|s
todestal|uer
toffel|n
toga|-1en
tomahawk|s
tomatenmark|e
ton|ue
tonie|s
toningenieur|e
tonsillitis|=Tonsillitiden
tool|s
tooltip|s
top|s
topf|ue
topfverschluß|=Topfverschlüsse
topp|en
torques|
tortellino|-1i
torus|-2i
totem|s
touch|s
toupet|s
törin|nen
törn|s
trabant|s
tragant|e
trägermaterial|=Trägermaterialien
tragetuch|uer
trail|s
trainee|s
training|s
tram|s
trank|ue
transfer|s
transferrin|e
transkript|e
trauerflor|e
trauerzug|ue
traum|ue
trauminet|s
traumjob|s
travertin|e
treck|s
treff|s
treibgut|uer
trema|=Tremata
tremor|=Tremores
trend|s
tresor|e
treuhand|en
trias|
tribus|-2en
trichobothrium|-2a
trick|s
triel|e
trikot|s
trinkglas|uer
trip|s
triphylin|e
tripod|s
triumphbogen|u
triumphzug|ue
trochäus|-2en
trockental|uer
trockentuch|uer
trog|ue
tropf|ue
trottoir|s
tröpferlbad|uer
truchseß|=Truchsesse
truck|s
trugschluß|=Trugschlüsse
trumm|uer
trumpf|ue
trunk|ue
trupp|s
trust|s
trübsal|e
trypanosoma|-1en
tschador|s
tschingg|en
tschusch|en
tulpenstrauss|ue
tumormedizin|en
tundra|-1en
tunesier|
tunika|-1en
tunnelzug|ue
tunwort|uer
turbojet|s
turboprop|s
turm|ue
turmalin|e
turn|s
turnsaal|=Turnsäle
turnus|se
tuwort|uer
tünnes|se
türspion|e
tüv|s
tvb|s
tweet|s
twen|s
twink|s
twist|s
typ|en
typenschild|er
typin|nen
typschild|er
typus|-2en
u-ausschuß|=U-Ausschüsse
ud|s
ulab|s
ulkus|=Ulzera
umbra|-1en
umfang|ue
umfeld|er
umgang|ue
umhang|ue
umlauf|ue
umlaufmarkt|e
umsatz|ue
umsatzrückgang|e
umsatzsteuerbetrug|e
umschlag|ue
umschwung|ue
umstand|ue
umstandswort|uer
umsturz|ue
umtrunk|ue
umzug|ue
unboxing|s
undercut|s
underdog|s
undorn|en
unfall|ue
unflat|ue
ungar|n
ungeheur|
ungustl|n
uni-bib|s
universalgenie|s
universitätsabschluß|=Universitätsabschlüsse
unkraut|uer
unterausschuß|=Unterausschüsse
unterbau|=Unterbauten
unterfaden|u
unterkunft|ue
unterpfand|uer
unterreddit|s
untersuchungsausschuß|=Untersuchungsausschüsse
unterton|ue
update|s
upload|s
urbild|er
urlaubsgeld|e
urmeer|e
urmutter|u
uroboros|-1i
ursatz|ue
urschrei|e
ursprung|ue
urstromtal|uer
urteilsdispositiv|s
urvater|u
urviech|er
urvieh|=Urviecher
urvogel|u
urwald|uer
usb|s
usv|s
utensil|=Utensilien
uterus|-2i
utrum|-2a
uvula|e
uwa|
überdach|e
überhang|e
übernahmerisiko|en
überschuß|=Überschüsse
überzug|ue
vadda|=Vädda
vagusnerv|en
vakzin|e
valet|s
vamp|s
vampirfledermaus|en
van|s
vanadiumstahl|ue
vanadocen|e
vanillecreme|s
varieté|s
varietee|s
vasculitis|=Vasculitiden
vater|u
vb|s
veggie|s
veilchenstrauss|ue
veitstanz|ue
velours|
vendetta|-1en
veranstaltungstermin|e
verb|en
verband|ue
verbotsirrtum|uer
verbraucherpreisindex|=Verbraucherpreisindizes
verdacht|ue
verdeck|e
verdruß|=Verdrüsse
vereinsausschluß|=Vereinsausschlüsse
vergrößerungsglas|uer
verhältniswort|uer
verhandlungsmacht|en
verkehrsschild|er
verlegenheitswort|uer
verlust|e
vermicelle|s
vermittlungsentgelt|er
verriß|=Verrisse
versal|=Versalien
verschissmus|-2en
verschluß|=Verschlüsse
versfuß|ue
versorgungsengpass|e
verstoss|ue
versus|-2en
verteidigungswall|ue
vertrag|ue
vertrauensvorschuß|=Vertrauensvorschüsse
verwertungsrisiko|en
verzug|ue
veterinärmedizin|en
vetter|n
vga|
vhs|
vibe|s
viech|er
vierkanthof|ue
viertelfinale|
vifzack|s
vigil|=Vigilien
villa|-1en
vinophiler|-1n
viola|-1en
vitamin|e
vitiligo|=Vitiligines
vivat|s
vizegouverneur|e
vizin|nen
vk|s
vogel|u
vogel-v|s
vogelzug|ue
vogt|ue
vokü|s
volatilitätsrückgang|e
volck|uer
volk|uer
volkseigentum|uer
volksgeist|er
volkstanz|ue
vollmacht|en
vollmantelgeschoß|=Vollmantelgeschosse
vollwort|uer
vollzug|ue
volt|s
volunteering|s
vorabdruck|e
vorbau|=Vorbauten
vorderrad|uer
vordruck|e
vorgewende|
vorhängeschloß|=Vorhängeschlösser
vorhof|ue
vormaterial|=Vormaterialien
vorrat|ue
vorschlaghammer|u
vorschuß|=Vorschüsse
vorsprung|ue
vorstoss|ue
vortrag|ue
vorwort|uer
vorzug|ue
voyeur|e
völva|=Völvur
vulkanier|
vulva|-1en
vw|
wachstumsvorsprung|ue
wachtelei|er
wagniskapitalmarkt|e
wahlrechtsausschluß|=Wahlrechtsausschlüsse
währungsmarkt|e
wald|uer
waldgeist|er
walhai|e
wall|ue
walnuß|=Walnüsse
walstatt|uen
wams|uer
wand|ue
wanst|ue
warnblinklicht|er
warnschild|er
warnschuß|=Warnschüsse
wartburg|s
wartesaal|=Wartesäle
warzenhof|ue
wasabi|
waschnuß|=Waschnüsse
waserl|n
wasserabfluß|=Wasserabflüsse
wasseranschluß|=Wasseranschlüsse
wasserbad|uer
wasserfaß|=Wasserfässer
wasserglas|uer
wasserpfeifenbar|s
wasserrad|uer
wasserschloß|=Wasserschlösser
wasserskorpion|e
wasserspeier|
wasserzufluß|=Wasserzuflüsse
watt|en
wattwurm|uer
wau|e
wc|s
wearable|s
webhook|s
webpräsenz|s
website|s
wechselkontingent|e
weckamin|e
weekend|s
wegwerfglas|uer
wehrersatzamt|uer
weib|er
weichei|er
weihnachtsgeld|e
weihnachtskranz|ue
weihrauchfaß|=Weihrauchfässer
weihwasser|u
weinfaß|=Weinfässer
weinglas|uer
weingut|uer
weinrot|
weißflügelpinguin|e
weisthum|uer
weistum|uer
weitsprung|ue
weltcup|s
weltstar|s
wendehammer|u
wenn|
werkzeugstahl|ue
werst|
wertpapiermarkt|e
wesenszug|ue
western|
wettbewerbsdruck|e
wettbewerbsvorteil|=Wettbewerbsvorteil-e
wetterglas|uer
wg|s
whatsapp|s
whiteboard|s
wholecar|s
wicht|er
widerrist|e
wiederkunft|ue
wiegendruck|e
wiel|en
wiesenrain|e
wiesn|
wieß|
wigwam|s
windrad|uer
wing|s
winkelzug|ue
wirtschaftsabschwung|e
wirtschaftsaufschwung|e
wirtschaftsboom|e
wirtschaftsklima|e
wirtschaftskraft|en
wissenschaftsmagazin|e
wissenssektor|e
wittum|uer
wka|s
wlan|s
wm|s
wohnungsbau|=Wohnungsbauten
wojenkomat|s
wok|s
wolf|ue
wolfsschwanz|ue
wollfaden|u
workstation|s
wortakzent|e
wortschatz|ue
wotin|nen
wp|
wrack|s
wrap|s
wuchs|ue
wunsch|ue
wurf|ue
wurst|ue
wurstfagott|e
würgaround|s
würstel|en
x-strahl|en
xenobiotikum|-2a
xerophyt|en
yarak|s
ylang-ylang|s
yobibyte|s
yoghurt|s
yottabyte|s
yuppie|s
zaddik|=Zaddikim
zahlenschloß|=Zahlenschlösser
zahlungskraft|en
zahlungsrückstand|e
zahlwort|uer
zahn|ue
zahncreme|s
zahnrad|uer
zanksucht|ue
zarentum|uer
zarin|nen
zauberwort|uer
zaum|ue
zaun|ue
zebibyte|s
zebrahai|e
zeh|en
zehnerl|
zeiland|e
zeilensprung|ue
zeitgeist|er
zeitungsredakteur|e
zeitwort|uer
zellaufschluß|=Zellaufschlüsse
zellenblock|ue
zeltboden|
zement|e
zensus|
zentralbank|en
zerberus|se
zettabyte|s
zeugma|=Zeugmata
ziehharmonikabus|se
ziel|e
ziffernsturz|ue
ziggurat|e
zikkurat|e
zikkurrat|e
zimmermannshammer|u
zink-pyrithion|e
zinkorganyle|
zinngießerwerkstatt|uen
zinnmineral|=Zinnmineralien
zins|en
zinsfuß|ue
zinsswap|s
zipp|s
zippverschluß|=Zippverschlüsse
ziqqurat|e
ziqqurrat|e
zirbelnuß|=Zirbelnüsse
zirkelschluß|=Zirkelschlüsse
zirkus|se
zitatwort|uer
zitronenhai|e
zoch|u
zodiakallicht|er
zoll|ue
zollamt|uer
zombie|s
zopf|ue
zölestin|e
zubau|=Zubauten
zucchetti|
zucchino|-1i
zuckerei|er
zuckerguß|=Zuckergüsse
zuckerhut|ue
zuckerl|
zufall|ue
zufluss|ue
zufluß|=Zuflüsse
zug|ue
zugang|ue
zugtyp|en
zukauf|ue
zukunft|ue
zulauf|ue
zumpf|ue
zund|
zunft|ue
zungenkuß|ue
zusammendruck|e
zusammenfluß|=Zusammenflüsse
zusammenkunft|ue
zusammenschluß|=Zusammenschlüsse
zusatz|ue
zusatzverkauf|e
zuschlag|ue
zuschuss|ue
zuschuß|=Zuschüsse
zuspiel|e
zustand|ue
zuwachs|ue
zuzug|ue
zügelpinguin|e
zündschnur|ue
zündstrick|e
zwang|ue
zweier|
zwergpinguin|e
zwischenstopp|s
zwischenton|ue
zwist|e
zyklus|-2en
zylinderhut|ue
zystitis|=Zystiden
zytokin|e
zytostatikum|-2a
zytotoxin|e
`;

const BLOCKED_DATA = `aber acker ader aktiv alken alter angel appel arsch aster back boskop chat dart diner dorn ecker eider eins elektronenvolt ende etat farm gate genie gesatz geschmack gespann gross groß handel hatz heck heuer house kamp korpus laub lava leck letter luch management mast merk mille minus miss modul molder mulle nichts niss njet oblast order ostern prostylos ranken rast raster reff ried ries riff rist rudel ruder rund same sarde schock schoss schoß spaß spund stag steuer stift stopp tallit tara than thorn tonie trend ufer ulti umsatz verdienst verzug vier vortrag wall werg wicht wutz zuwachs übel`;

const GENDER_NAMES: Record<string, GrammaticalGender> = {
  m: "masculine",
  f: "feminine",
  n: "neuter",
};

/** Nouns whose gender contradicts what their ending suggests. */
export const GENDERS: ReadonlyMap<string, GrammaticalGender> = new Map(
  GENDER_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => {
      const [lemma, gender] = line.split("|") as [string, string];
      return [lemma, GENDER_NAMES[gender] ?? "masculine"] as const;
    }),
);

/** Nouns whose plural the rules do not produce. Values are codes. */
export const PLURALS: ReadonlyMap<string, string> = new Map(
  PLURAL_DATA.split("\n")
    .filter((line) => line.length > 0)
    .map((line) => line.split("|") as [string, string]),
);

/**
 * Nouns that make bad compound heads, measured against the corpus: taking
 * them as the final element gets more compounds wrong than right.
 */
export const BLOCKED_HEADS: ReadonlySet<string> = new Set(BLOCKED_DATA.split(" "));

/** The three tables together, as the resolver wants them. */
export const LEXICON = { genders: GENDERS, plurals: PLURALS, blockedHeads: BLOCKED_HEADS };
